const products = [
  {
    id: 1,
    productName: "DAI BAY",
    technicalName: "Diafenthiuron 47% + Bifenthrin 9.4%",
    formulation: "SC",
    category: "Insecticide",
    packSize: "—",
    image: "/images/products/1.jpeg",
    description: "DAI BAY is a powerful combination insecticide containing Diafenthiuron and Bifenthrin, designed for effective control of sucking and chewing pests. It provides long-lasting protection against insects like aphids, whiteflies, and caterpillars, ensuring healthier crops, better foliage growth, and improved yield quality across various agricultural crops."
  },
  {
    id: 2,
    productName: "SUCCESS",
    technicalName: "Fipronil 2.92%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/2.jpeg",
    description: "SUCCESS is a broad-spectrum insecticide based on Fipronil, offering excellent control over soil and foliar pests. It effectively manages termites, borers, and leaf-eating insects. Its fast action and residual effect help protect crops during critical growth stages, ensuring sustained pest control and higher productivity."
  },
  {
    id: 3,
    productName: "ENDO",
    technicalName: "Myclobutanil 10%",
    formulation: "WP",
    category: "Fungicide",
    packSize: "—",
    image: "/images/products/3.jpeg",
    description: "ENDO is a systemic fungicide containing Myclobutanil, widely used for controlling powdery mildew and other fungal diseases. It works by inhibiting fungal growth at the cellular level, promoting healthier plants, improved disease resistance, and better crop development with long-lasting protective and curative action."
  },
  {
    id: 4,
    productName: "COFFEE GR",
    technicalName: "Imidacloprid 0.3%",
    formulation: "GR",
    category: "Insecticide",
    packSize: "3 Kg, 1 Kg",
    image: "/images/products/4.jpeg",
    description: "COFFEE GR is a granular insecticide formulated with Imidacloprid for effective control of soil-dwelling and sucking pests. It provides systemic protection by being absorbed through roots, ensuring long-term pest management. Ideal for plantation and field crops, it enhances plant vigor and overall crop health."
  },
  {
    id: 5,
    productName: "AYOBA",
    technicalName: "Chlorpyrifos 16% + Alphacypermethrin 1%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/5.jpeg",
    description: "AYOBA is a dual-action insecticide combining Chlorpyrifos and Alphacypermethrin for rapid and long-lasting pest control. It effectively controls a wide range of chewing and sucking insects. The formulation ensures quick knockdown, extended residual action, and reliable crop protection throughout the growing season."
  },
  {
    id: 6,
    productName: "JADUGAR",
    technicalName: "Biozyme (Organic formulation)",
    formulation: "Granules",
    category: "Plant Growth Regulator",
    packSize: "10 Kg",
    image: "/images/products/6.jpeg",
    description: "JADUGAR is an organic plant growth regulator enriched with bio-enzymes that improve soil health and plant metabolism. It enhances root development, nutrient absorption, and overall plant growth. Regular application helps improve crop vigor, stress tolerance, and yield potential in an eco-friendly manner."
  },
  {
    id: 7,
    productName: "MAGIC-GR",
    technicalName: "Micronutrient Mixture",
    formulation: "GR",
    category: "Fertilizer",
    packSize: "1 Kg",
    image: "/images/products/7.jpeg",
    description: "MAGIC-GR is a balanced micronutrient mixture designed to correct nutrient deficiencies in crops. It improves chlorophyll formation, enhances photosynthesis, and supports healthy plant growth. Suitable for various crops, it promotes better flowering, fruit development, and improved yield quality."
  },
  {
    id: 8,
    productName: "PROCEF SUPER-44",
    technicalName: "Profenofos 40% + Cypermethrin 4%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/8.jpeg",
    description: "PROCEF SUPER-44 is a combination insecticide containing Profenofos and Cypermethrin for effective control of resistant pests. It offers both contact and stomach action, ensuring quick pest knockdown and extended protection. Ideal for cotton and vegetables, it supports healthier crops and higher yields."
  },
  {
    id: 9,
    productName: "ADMIT-70",
    technicalName: "Imidacloprid 70%",
    formulation: "WG",
    category: "Insecticide",
    packSize: "150 gm, 60 gm, 30 gm",
    image: "/images/products/9.jpeg",
    description: "ADMIT-70 is a highly concentrated systemic insecticide based on Imidacloprid WG formulation. It provides effective control against sucking pests like aphids, jassids, and whiteflies. Its quick absorption and long residual activity help maintain pest-free crops and improved overall crop performance."
  },
  {
    id: 10,
    productName: "JASBA",
    technicalName: "Pyriproxyfen 10%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml",
    image: "/images/products/10.jpeg",
    description: "JASBA is an insect growth regulator containing Pyriproxyfen, specially formulated to control whiteflies and other sap-sucking pests. It disrupts insect life cycles by preventing reproduction. This ensures long-term pest suppression, reduced resistance risk, and improved crop health with minimal environmental impact."
  },
  {
    id: 11,
    productName: "ULTRA GREEN",
    technicalName: "Humic Acid 95%",
    formulation: "Liquid",
    category: "Plant Growth Regulator",
    packSize: "25 Kg, 1 Kg, 500 gm, 250 gm",
    image: "/images/products/11.jpeg",
    description: "ULTRA GREEN is a high-quality humic acid-based plant growth regulator that improves soil structure and nutrient availability. It enhances root growth, water retention, and nutrient uptake. Regular use promotes strong plant development, increased stress tolerance, and higher yield potential across crops."
  },
  {
    id: 12,
    productName: "JET 500",
    technicalName: "Chlorpyriphos 50% + Cypermethrin 5%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/12.jpeg",
    description: "JET 500 is a broad-spectrum insecticide combining Chlorpyriphos and Cypermethrin for effective pest management. It controls a wide range of insects with quick knockdown action and long residual effect. Suitable for multiple crops, it ensures consistent protection and better crop productivity."
  },
  {
    id: 13,
    productName: "MAKAU",
    technicalName: "Metribuzin 42% + Clodinafop Propargyl 12%",
    formulation: "WG",
    category: "Herbicide",
    packSize: "1 Kg, 500 gm, 250 gm",
    image: "/images/products/13.jpeg",
    description: "MAKAU is a selective herbicide combination of Metribuzin and Clodinafop Propargyl for effective weed control. It targets both grassy and broadleaf weeds, reducing crop competition. The formulation ensures improved weed management, better crop establishment, and enhanced yield potential."
  },
  {
    id: 14,
    productName: "COPITA-4G",
    technicalName: "Cartap Hydrochloride 4%",
    formulation: "GR",
    category: "Insecticide",
    packSize: "5 Kg, 1 Kg",
    image: "/images/products/14.jpeg",
    description: "COPITA-4G is a granular insecticide containing Cartap Hydrochloride, effective against stem borers and soil pests. It provides systemic and contact action, ensuring long-lasting control. Ideal for paddy and other crops, it helps protect crops during early growth stages."
  },
  {
    id: 15,
    productName: "BORIYA",
    technicalName: "Buprofezin 22% + Fipronil 3%",
    formulation: "SC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/15.jpeg",
    description: "BORIYA is a combination insecticide formulated with Buprofezin and Fipronil to control sucking pests and insect larvae. It works by inhibiting pest growth and providing residual protection. Suitable for various crops, it supports improved pest management and healthier plant development."
  },
  {
    id: 16,
    productName: "DENAL",
    technicalName: "Fenpropathrin 10%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/16.jpeg",
    description: "DENAL is a synthetic pyrethroid insecticide containing Fenpropathrin for fast-acting pest control. It effectively manages mites and insect pests through contact and stomach action. Its rapid knockdown and residual activity help maintain crop health and reduce yield losses."
  },
  {
    id: 17,
    productName: "ELE-75",
    technicalName: "Cartap Hydrochloride 75%",
    formulation: "SG",
    category: "Insecticide",
    packSize: "—",
    image: "/images/products/17.jpeg",
    description: "ELE-75 is a highly concentrated soluble granule insecticide based on Cartap Hydrochloride. It offers effective control of borers and chewing pests with systemic action. The formulation ensures easy application, consistent pest control, and improved crop safety during critical growth stages."
  },
  {
    id: 18,
    productName: "BAGUTI 5G",
    technicalName: "Butachlor 5%",
    formulation: "GR",
    category: "Herbicide",
    packSize: "5 Kg, 1 Kg, 500 gm, 250 gm",
    image: "/images/products/18.jpeg",
    description: "BAGUTI 5G is a granular herbicide containing Butachlor, widely used for weed control in transplanted crops. It controls annual grasses and broadleaf weeds effectively. Early application reduces weed competition, supports healthy crop establishment, and improves overall field productivity."
  },
  {
    id: 19,
    productName: "CYMIN",
    technicalName: "Chlorimuron Ethyl 25%",
    formulation: "WP",
    category: "Herbicide",
    packSize: "15 gm",
    image: "/images/products/19.jpeg",
    description: "CYMIN is a selective herbicide formulated with Chlorimuron Ethyl for controlling broadleaf weeds. It is absorbed through foliage and roots, inhibiting weed growth at an early stage. Ideal for soybean and pulse crops, it improves crop growth and yield potential."
  },
  {
    id: 20,
    productName: "AVIKA",
    technicalName: "Thiamethoxam 12.6% + Lambda-Cyhalothrin 9.5%",
    formulation: "ZC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml",
    image: "/images/products/20.jpeg",
    description: "AVIKA is a modern combination insecticide containing Thiamethoxam and Lambda-Cyhalothrin for broad-spectrum pest control. It provides quick knockdown and systemic protection against sucking and chewing pests, ensuring long-lasting crop protection, improved plant health, and higher yields."
  },
  {
    id: 21,
    productName: "CORTHIN-DP",
    technicalName: "Malathion 5%",
    formulation: "DP",
    category: "Insecticide",
    packSize: "3 Kg, 1 Kg, 500 gm",
    image: "/images/products/21.jpeg",
    description: "CORTHIN-DP is a dust formulation insecticide containing Malathion, used for effective control of household and field crop insects. It controls flies, mosquitoes, and crawling pests through contact action. Easy to apply, it ensures quick results and helps maintain hygienic and pest-free crop surroundings."
  },
  {
    id: 22,
    productName: "DAPULI",
    technicalName: "Quinalphos 25%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/22.jpeg",
    description: "DAPULI is a broad-spectrum organophosphate insecticide formulated with Quinalphos. It provides effective control of chewing and sucking pests in various crops. The formulation offers contact and stomach action, ensuring quick pest knockdown, reduced crop damage, and improved crop productivity."
  },
  {
    id: 23,
    productName: "CAPCHIN",
    technicalName: "Captan 50%",
    formulation: "WP",
    category: "Fungicide",
    packSize: "1 Kg, 500 gm, 250 gm",
    image: "/images/products/23.jpeg",
    description: "CAPCHIN is a protective fungicide containing Captan, widely used for controlling seed-borne and soil-borne fungal diseases. It protects crops from leaf spots, blights, and rots. The formulation improves plant health, ensures better seedling establishment, and supports higher crop yields."
  },
  {
    id: 24,
    productName: "DOUBLE CUT",
    technicalName: "Emamectin Benzoate 1.9%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml, 20 ml",
    image: "/images/products/24.jpeg",
    description: "DOUBLE CUT is a highly effective insecticide based on Emamectin Benzoate, designed to control caterpillars and lepidopteran pests. It provides stomach action and rapid pest paralysis. Suitable for vegetables and field crops, it ensures reduced crop damage and improved yield quality."
  },
  {
    id: 25,
    productName: "SIMOTA",
    technicalName: "Azadirachtin 1% (Neem Seed Kernel Based)",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/25.jpeg",
    description: "SIMOTA is a neem-based botanical insecticide containing Azadirachtin, offering eco-friendly pest control. It acts as a feeding deterrent and growth regulator for insects. Ideal for integrated pest management, it helps reduce pest resistance while maintaining crop safety and environmental balance."
  },
  {
    id: 26,
    productName: "HALFAN",
    technicalName: "Fenvalerate 20%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/26.jpeg",
    description: "HALFAN is a synthetic pyrethroid insecticide containing Fenvalerate for fast and effective pest control. It provides strong contact and stomach action against a wide range of insects. The formulation ensures quick knockdown, extended residual effect, and reliable protection for multiple crops."
  },
  {
    id: 27,
    productName: "ALINDA-GR",
    technicalName: "Fipronil 0.3%",
    formulation: "GR",
    category: "Insecticide",
    packSize: "5 Kg, 1 Kg",
    image: "/images/products/27.jpeg",
    description: "ALINDA-GR is a granular insecticide formulated with Fipronil for effective control of soil-dwelling pests. It provides long-lasting protection against termites and root-feeding insects. Absorbed gradually, it ensures sustained pest control and supports healthy early-stage crop growth."
  },
  {
    id: 28,
    productName: "ALINDA-ULTRA",
    technicalName: "Fipronil 0.6%",
    formulation: "GR",
    category: "Insecticide",
    packSize: "5 Kg, 1 Kg",
    image: "/images/products/28.jpeg",
    description: "ALINDA-ULTRA is an enhanced granular insecticide containing Fipronil with higher concentration for stronger pest control. It effectively manages soil and root pests with extended residual activity. Ideal for plantation and field crops, it improves plant establishment and overall crop health."
  },
  {
    id: 29,
    productName: "SCON",
    technicalName: "Difenoconazole 25%",
    formulation: "EC",
    category: "Fungicide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml",
    image: "/images/products/29.jpeg",
    description: "SCON is a systemic fungicide based on Difenoconazole, used to control a wide range of fungal diseases. It offers both preventive and curative action by inhibiting fungal development. The formulation promotes healthier foliage, better disease management, and improved crop yield potential."
  },
  {
    id: 30,
    productName: "SPEED",
    technicalName: "Zineb 75%",
    formulation: "WP",
    category: "Fungicide",
    packSize: "1 Kg, 500 gm, 250 gm",
    image: "/images/products/30.jpeg",
    description: "SPEED is a contact fungicide formulated with Zineb for effective disease prevention. It controls leaf spots, blights, and downy mildew in various crops. Regular application helps protect plants from fungal infections, improves crop vigor, and supports consistent and healthy crop growth."
  },
  {
    id: 31,
    productName: "LIHOMIN",
    technicalName: "Chlormequat Chloride 50%",
    formulation: "SL",
    category: "Plant Growth Regulator",
    packSize: "—",
    image: "/images/products/31.jpeg",
    description: "LIHOMIN is a plant growth regulator containing Chlormequat Chloride, used to control excessive vegetative growth. It improves plant structure, enhances flowering, and reduces lodging in crops. The formulation helps achieve balanced growth and better yield management."
  },
  {
    id: 32,
    productName: "CORTHIN",
    technicalName: "Malathion 50%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/32.jpeg",
    description: "CORTHIN is a broad-spectrum insecticide formulated with Malathion for effective pest control. It works through contact action to manage sucking and chewing insects. Suitable for multiple crops, it helps reduce pest infestation, protects crop health, and supports higher agricultural productivity."
  },
  {
    id: 33,
    productName: "PICKLO",
    technicalName: "Flonicamid 50%",
    formulation: "WG",
    category: "Insecticide",
    packSize: "1 Kg, 500 gm, 250 gm, 100 gm",
    image: "/images/products/33.jpeg",
    description: "PICKLO is a modern insecticide containing Flonicamid, specifically designed for controlling sucking pests. It disrupts insect feeding activity, leading to rapid pest suppression. Ideal for cotton and vegetables, it ensures effective control with minimal impact on beneficial insects."
  },
  {
    id: 34,
    productName: "KOHIL",
    technicalName: "Cymoxanil 8% + Mancozeb 64%",
    formulation: "WP",
    category: "Fungicide",
    packSize: "1 Kg, 500 gm, 250 gm, 100 gm",
    image: "/images/products/34.jpeg",
    description: "KOHIL is a combination fungicide containing Cymoxanil and Mancozeb for effective disease control. It offers both systemic and contact action against late blight and other fungal diseases. The formulation ensures strong disease protection, healthier crops, and improved yield stability."
  },
  {
    id: 35,
    productName: "MAKDI",
    technicalName: "Fipronil 4% + Thiamethoxam 4%",
    formulation: "SC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml, 20 ml",
    image: "/images/products/35.jpeg",
    description: "MAKDI is a powerful combination insecticide formulated with Fipronil and Thiamethoxam. It provides systemic and contact action against a wide range of pests. The formulation ensures quick pest control, long residual activity, and improved plant health throughout the crop cycle."
  },
  {
    id: 36,
    productName: "HALTOR",
    technicalName: "Paclobutrazol 23%",
    formulation: "SC",
    category: "Plant Growth Regulator",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/36.jpeg",
    description: "HALTOR is a plant growth regulator containing Paclobutrazol, used to control excessive vegetative growth and improve flowering. It enhances root development and stress tolerance. Suitable for fruit and plantation crops, it supports better crop management and yield optimization."
  },
  {
    id: 37,
    productName: "SAKAMA-55",
    technicalName: "Sulphur 55.16%",
    formulation: "SC",
    category: "Fungicide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/37.jpeg",
    description: "SAKAMA-55 is a sulphur-based fungicide effective against powdery mildew and mite infestations. It improves plant resistance and supports healthy growth. The formulation provides protective action, enhances crop quality, and helps maintain disease-free crop conditions."
  },
  {
    id: 38,
    productName: "GICHITA",
    technicalName: "Profenofos 40% + Fenpyroximate 2.5%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/38.jpeg",
    description: "GICHITA is a combination insecticide containing Profenofos and Fenpyroximate for effective control of insects and mites. It offers contact and stomach action with rapid knockdown. Suitable for various crops, it ensures reliable pest management and improved crop performance."
  },
  {
    id: 39,
    productName: "DOSHI BA",
    technicalName: "Deltamethrin 11%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "—",
    image: "/images/products/39.jpeg",
    description: "DOSHI BA is a pyrethroid insecticide formulated with Deltamethrin for quick pest control. It provides strong contact action against a wide range of insects. The formulation ensures fast knockdown, extended protection, and effective pest management in agricultural crops."
  },
  {
    id: 40,
    productName: "DUM",
    technicalName: "Lambda-Cyhalothrin 4.9%",
    formulation: "CS",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/40.jpeg",
    description: "DUM is a capsule suspension insecticide containing Lambda-Cyhalothrin for effective pest control. It provides rapid knockdown and residual action against chewing and sucking pests. The advanced formulation ensures better stability, improved safety, and long-lasting crop protection."
  },
  {
    id: 41,
    productName: "CORINA",
    technicalName: "Chlorantraniliprole 18.5%",
    formulation: "SC",
    category: "Insecticide",
    packSize: "800 ml, 500 ml, 150 ml, 80 ml, 30 ml",
    image: "/images/products/41.jpeg",
    description: "CORINA is a modern insecticide containing Chlorantraniliprole, effective against lepidopteran pests like caterpillars and borers. It provides long-lasting control by affecting insect muscle function. The formulation ensures excellent crop safety, reduced pest damage, and improved yield quality in various crops."
  },
  {
    id: 42,
    productName: "MAKRANA",
    technicalName: "Glyphosate Ammonium Salt 20%",
    formulation: "SL",
    category: "Herbicide",
    packSize: "1 Kg, 500 gm, 250 gm",
    image: "/images/products/42.jpeg",
    description: "MAKRANA is a non-selective systemic herbicide formulated with Glyphosate Ammonium Salt. It controls a wide range of annual and perennial weeds by inhibiting plant growth processes. Ideal for pre-planting and non-crop areas, it helps maintain clean fields and reduces weed competition."
  },
  {
    id: 43,
    productName: "ALPHAGRO",
    technicalName: "Alphacypermethrin 10%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/43.jpeg",
    description: "ALPHAGRO is a synthetic pyrethroid insecticide containing Alphacypermethrin for fast knockdown of pests. It works through contact and stomach action against chewing and sucking insects. Suitable for multiple crops, it provides quick control and extended residual protection."
  },
  {
    id: 44,
    productName: "JATAHIL",
    technicalName: "Chlorothalonil 75%",
    formulation: "WP",
    category: "Fungicide",
    packSize: "1 Kg, 500 gm, 250 gm, 100 gm",
    image: "/images/products/44.jpeg",
    description: "JATAHIL is a contact fungicide based on Chlorothalonil, used for controlling fungal diseases like leaf spots and blights. It provides preventive protection by forming a protective barrier on plant surfaces. The formulation ensures healthier foliage and improved disease management."
  },
  {
    id: 45,
    productName: "COP-15",
    technicalName: "Clodinafop-propargyl 15%",
    formulation: "WP",
    category: "Herbicide",
    packSize: "150 gm",
    image: "/images/products/45.jpeg",
    description: "COP-15 is a selective post-emergence herbicide containing Clodinafop-propargyl, effective against grassy weeds. It is absorbed through leaves and inhibits weed growth without harming crops. Ideal for wheat cultivation, it improves crop establishment and yield potential."
  },
  {
    id: 46,
    productName: "HY-PINDA",
    technicalName: "Pendimethalin 30%",
    formulation: "EC",
    category: "Herbicide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/46.jpeg",
    description: "HY-PINDA is a pre-emergence herbicide formulated with Pendimethalin for effective weed control. It controls annual grasses and broadleaf weeds by inhibiting seed germination. Early application helps reduce weed competition and supports healthy crop growth."
  },
  {
    id: 47,
    productName: "FILLAR",
    technicalName: "Glufosinate Ammonium 13.5%",
    formulation: "SL",
    category: "Herbicide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/47.jpeg",
    description: "FILLAR is a non-selective contact herbicide containing Glufosinate Ammonium. It controls a broad spectrum of weeds by inhibiting photosynthesis. Suitable for orchards and plantation crops, it ensures quick weed control and cleaner field conditions."
  },
  {
    id: 48,
    productName: "KING-95 SG",
    technicalName: "Acephate 95%",
    formulation: "SG",
    category: "Insecticide",
    packSize: "1 Kg, 500 gm, 250 gm, 100 gm, 50 gm",
    image: "/images/products/48.jpeg",
    description: "KING-95 SG is a highly concentrated systemic insecticide based on Acephate. It effectively controls sucking and chewing pests through contact and stomach action. The soluble granule formulation ensures easy application, rapid absorption, and reliable pest control across crops."
  },
  {
    id: 49,
    productName: "JAMPULA",
    technicalName: "Fipronil 80%",
    formulation: "WG",
    category: "Insecticide",
    packSize: "10 gm, 20 gm",
    image: "/images/products/49.jpeg",
    description: "JAMPULA is a high-strength insecticide containing Fipronil WG formulation for effective pest management. It controls soil and foliar pests with long residual action. Suitable for low-dose application, it ensures strong pest suppression and improved crop protection."
  },
  {
    id: 50,
    productName: "HINOTHRIN",
    technicalName: "Fenpropathrin 30%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/50.jpeg",
    description: "HINOTHRIN is a pyrethroid insecticide containing Fenpropathrin for fast and effective control of insects and mites. It offers contact and stomach action with quick knockdown. The formulation ensures long-lasting protection and healthier crop growth."
  },
  {
    id: 51,
    productName: "PLANO-X",
    technicalName: "Alpha Naphthyl Acetic Acid 4.5%",
    formulation: "SL",
    category: "Plant Growth Regulator",
    packSize: "250 ml, 100 ml",
    image: "/images/products/51.jpeg",
    description: "PLANO-X is a plant growth regulator containing Alpha Naphthyl Acetic Acid, used to promote flowering and reduce premature fruit drop. It improves fruit setting and uniform growth. Suitable for horticultural crops, it helps enhance yield quality and consistency."
  },
  {
    id: 52,
    productName: "OZZY",
    technicalName: "Indoxacarb 14.5% + Acetamiprid 7.7%",
    formulation: "SC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml",
    image: "/images/products/52.jpeg",
    description: "OZZY is a combination insecticide containing Indoxacarb and Acetamiprid for broad-spectrum pest control. It provides contact, systemic, and stomach action against major insect pests. The formulation ensures quick knockdown, prolonged protection, and improved crop health."
  },
  {
    id: 53,
    productName: "PROCEF-50",
    technicalName: "Profenophos 50%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/53.jpeg",
    description: "PROCEF-50 is a broad-spectrum insecticide formulated with Profenophos for effective control of resistant pests. It works through contact and stomach action, providing quick knockdown. Suitable for cotton and vegetables, it ensures consistent pest management and yield protection."
  },
  {
    id: 54,
    productName: "TILOTI",
    technicalName: "Propiconazole 25%",
    formulation: "EC",
    category: "Fungicide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/54.jpeg",
    description: "TILOTI is a systemic fungicide containing Propiconazole, used to control leaf spots, rusts, and powdery mildew. It offers preventive and curative action by inhibiting fungal growth. The formulation promotes healthy foliage and improved crop productivity."
  },
  {
    id: 55,
    productName: "DAPULI-DP",
    technicalName: "Quinalphos 1.5%",
    formulation: "DP",
    category: "Insecticide",
    packSize: "1 Kg, 500 gm, 250 gm",
    image: "/images/products/55.jpeg",
    description: "DAPULI-DP is a dust formulation insecticide containing Quinalphos for effective control of household and field pests. It works through contact action to reduce insect infestation. Easy to apply, it helps maintain pest-free crop surroundings and storage areas."
  },
  {
    id: 56,
    productName: "MANPRO",
    technicalName: "Emamectin Benzoate 1.5% + Profenofos 35%",
    formulation: "WDG",
    category: "Insecticide",
    packSize: "—",
    image: "/images/products/56.jpeg",
    description: "MANPRO is a powerful combination insecticide containing Emamectin Benzoate and Profenophos. It provides both stomach and contact action against caterpillars and other pests. The formulation ensures rapid pest control, extended protection, and improved crop performance."
  },
  {
    id: 57,
    productName: "KOMIL",
    technicalName: "Fenoxaprop-P-ethyl 9.3%",
    formulation: "EC",
    category: "Herbicide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/57.jpeg",
    description: "KOMIL is a selective post-emergence herbicide containing Fenoxaprop-P-ethyl for controlling grassy weeds. It is absorbed through foliage and disrupts weed growth. Suitable for rice and other crops, it reduces weed competition and supports higher yields."
  },
  {
    id: 58,
    productName: "SUPRIYO",
    technicalName: "Glyphosate IPA Salt 54%",
    formulation: "SL",
    category: "Herbicide",
    packSize: "1 L, 500 ml",
    image: "/images/products/58.jpeg",
    description: "SUPRIYO is a systemic herbicide formulated with Glyphosate IPA Salt for broad-spectrum weed control. It effectively controls annual and perennial weeds by translocating throughout the plant. Ideal for non-crop areas and pre-plant use, it ensures long-term weed management."
  },
  {
    id: 59,
    productName: "SUPER LINE",
    technicalName: "Pyraclostrobin 20%",
    formulation: "WG",
    category: "Fungicide",
    packSize: "1 Kg, 500 gm, 250 gm",
    image: "/images/products/59.jpeg",
    description: "SUPER LINE is a strobilurin fungicide containing Pyraclostrobin for effective disease control. It improves plant respiration and controls fungal infections. The formulation enhances crop vigor, disease resistance, and overall yield potential."
  },
  {
    id: 60,
    productName: "TOP STAR",
    technicalName: "Azoxystrobin 18.2% + Difenoconazole 11.4%",
    formulation: "SC",
    category: "Fungicide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml",
    image: "/images/products/60.jpeg",
    description: "TOP STAR is a combination fungicide containing Azoxystrobin and Difenoconazole for broad-spectrum disease control. It offers preventive and curative action against major fungal diseases. The formulation ensures long-lasting protection, healthier plants, and improved crop yield."
  },
  {
    id: 61,
    productName: "TYCON",
    technicalName: "Fipronil 4% + Acetamiprid 4%",
    formulation: "SC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/61.jpeg",
    description: "TYCON is a combination insecticide containing Fipronil and Acetamiprid, designed for effective control of sucking and chewing pests. It provides contact and systemic action for quick knockdown and long residual protection. Suitable for multiple crops, it helps maintain healthy plants and improved yield performance."
  },
  {
    id: 62,
    productName: "KANIBU",
    technicalName: "Buprofezin 25%",
    formulation: "SC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/62.jpeg",
    description: "KANIBU is a selective insecticide formulated with Buprofezin for controlling whiteflies and other sucking pests. It works by inhibiting insect growth and molting. The formulation ensures long-term pest suppression, reduced resistance risk, and improved crop health."
  },
  {
    id: 63,
    productName: "BAGUTI-50",
    technicalName: "Butachlor 50%",
    formulation: "EC",
    category: "Herbicide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/63.jpeg",
    description: "BAGUTI-50 is a pre-emergence herbicide containing Butachlor, widely used for weed control in transplanted crops. It effectively controls annual grasses and broadleaf weeds. Early application reduces weed competition, supports uniform crop establishment, and improves field productivity."
  },
  {
    id: 64,
    productName: "MARKAR",
    technicalName: "Diclosulam 84%",
    formulation: "WG",
    category: "Herbicide",
    packSize: "—",
    image: "/images/products/64.jpeg",
    description: "MARKAR is a selective herbicide formulated with Diclosulam for effective control of broadleaf weeds. It is absorbed through roots and shoots, inhibiting weed growth at an early stage. Ideal for soybean and pulse crops, it supports better crop development and yield."
  },
  {
    id: 65,
    productName: "TIMSHO",
    technicalName: "Paclobutrazol 40%",
    formulation: "SC",
    category: "Plant Growth Regulator",
    packSize: "1 L, 500 ml, 250 ml, 100 ml",
    image: "/images/products/65.jpeg",
    description: "TIMSHO is a plant growth regulator containing Paclobutrazol, used to manage excessive vegetative growth. It enhances flowering, improves root strength, and increases stress tolerance. Suitable for fruit and plantation crops, it helps optimize growth and yield quality."
  },
  {
    id: 66,
    productName: "ODIBU",
    technicalName: "Buprofezin 20% + Acephate 50%",
    formulation: "WP",
    category: "Insecticide",
    packSize: "1 Kg, 500 gm, 250 gm",
    image: "/images/products/66.jpeg",
    description: "ODIBU is a combination insecticide containing Buprofezin and Acephate for effective control of sucking pests. It provides systemic and contact action for rapid pest reduction. The formulation ensures long-lasting protection, healthier crops, and improved productivity."
  },
  {
    id: 67,
    productName: "KOSTA",
    technicalName: "Diafenthiuron 40.1% + Acetamiprid 3.9%",
    formulation: "WP",
    category: "Insecticide",
    packSize: "1 Kg, 500 gm, 250 gm, 100 gm",
    image: "/images/products/67.jpeg",
    description: "KOSTA is a powerful combination insecticide formulated with Diafenthiuron and Acetamiprid. It effectively controls resistant sucking pests with contact and systemic action. The formulation ensures quick pest control, extended residual activity, and improved crop safety."
  },
  {
    id: 68,
    productName: "PORT-50",
    technicalName: "Phenthoate 50%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/68.jpeg",
    description: "PORT-50 is a broad-spectrum organophosphate insecticide containing Phenthoate. It provides effective control of chewing and sucking insects through contact and stomach action. Suitable for various crops, it ensures quick knockdown and reliable pest management."
  },
  {
    id: 69,
    productName: "PEX",
    technicalName: "Pyraclostrobin 133 g/L + Epoxiconazole 50 g/L",
    formulation: "SE",
    category: "Fungicide",
    packSize: "—",
    image: "/images/products/69.jpeg",
    description: "PEX is a modern combination fungicide containing Pyraclostrobin and Epoxiconazole for broad-spectrum disease control. It offers preventive and curative action against major fungal diseases. The formulation improves plant vigor, disease resistance, and overall crop yield."
  },
  {
    id: 70,
    productName: "CHIP-CHIP",
    technicalName: "Silicone Based Spreader & Activator",
    formulation: "—",
    category: "Plant Growth Regulator",
    packSize: "500 ml, 250 ml, 100 ml, 50 ml",
    image: "/images/products/70.jpeg",
    description: "CHIP-CHIP is a silicone-based spreader and activator that improves spray coverage and absorption. It enhances the effectiveness of pesticides by reducing surface tension. Suitable for all crops, it ensures uniform spray distribution, better penetration, and improved treatment efficiency."
  },
  {
    id: 71,
    productName: "CODI-15",
    technicalName: "Clodinafop-propargyl 15%",
    formulation: "WP",
    category: "Herbicide",
    packSize: "150 gm",
    image: "/images/products/71.jpeg",
    description: "CODI-15 is a selective post-emergence herbicide containing Clodinafop-propargyl for controlling grassy weeds. It is absorbed through foliage and inhibits weed growth without affecting crops. Ideal for wheat cultivation, it improves weed management and yield potential."
  },
  {
    id: 72,
    productName: "V-SUPER",
    technicalName: "Fenoxaprop-p-ethyl 9.3%",
    formulation: "EC",
    category: "Herbicide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/72.jpeg",
    description: "V-SUPER is a selective post-emergence herbicide formulated with Fenoxaprop-p-ethyl for effective control of grassy weeds. It is rapidly absorbed and disrupts weed growth. Suitable for rice and other crops, it helps reduce weed competition and supports higher yields."
  },
  {
    id: 73,
    productName: "ONESIL",
    technicalName: "Quizalofop-ethyl 4% + Oxyfluorfen 6%",
    formulation: "EC",
    category: "Herbicide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/73.jpeg",
    description: "ONESIL is a combination herbicide containing Quizalofop-ethyl and Oxyfluorfen for effective control of grasses and broadleaf weeds. It offers both pre- and post-emergence action. The formulation ensures improved weed control and better crop establishment."
  },
  {
    id: 74,
    productName: "SADIRA",
    technicalName: "Cypermethrin 10% + Indoxacarb 10%",
    formulation: "SC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/74.jpeg",
    description: "SADIRA is a combination insecticide formulated with Cypermethrin and Indoxacarb for broad-spectrum pest control. It provides quick knockdown and residual action against major insect pests. Suitable for multiple crops, it ensures reliable protection and healthier crop growth."
  },
  {
    id: 75,
    productName: "OCTIV",
    technicalName: "Sulfosulfuron 75%",
    formulation: "WG",
    category: "Herbicide",
    packSize: "—",
    image: "/images/products/75.jpeg",
    description: "OCTIV is a selective herbicide containing Sulfosulfuron for controlling grassy and broadleaf weeds. It is absorbed through leaves and roots, inhibiting weed growth. Ideal for wheat crops, it improves weed management and supports better crop productivity."
  },
  {
    id: 76,
    productName: "KAKEDA-G",
    technicalName: "Quinalphos 5%",
    formulation: "G (Granules)",
    category: "Insecticide",
    packSize: "1 Kg, 500 gm, 250 gm",
    image: "/images/products/76.jpeg",
    description: "KAKEDA-G is a granular insecticide formulated with Quinalphos for effective control of soil and foliar pests. It provides contact action and long-lasting protection. Suitable for various crops, it helps reduce early-stage pest damage and improve crop establishment."
  },
  {
    id: 77,
    productName: "ZOOMAX",
    technicalName: "Oxyfluorfen 2.5% + Glyphosate 41%",
    formulation: "SC",
    category: "Herbicide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/77.jpeg",
    description: "ZOOMAX is a non-selective herbicide combining Oxyfluorfen and Glyphosate for broad-spectrum weed control. It effectively controls annual and perennial weeds. Suitable for non-crop areas and orchards, it ensures clean fields and reduced weed competition."
  },
  {
    id: 78,
    productName: "LEETA-58",
    technicalName: "2,4-D Amine Salt 58%",
    formulation: "SL",
    category: "Herbicide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/78.jpeg",
    description: "LEETA-58 is a systemic herbicide formulated with 2,4-D Amine Salt for effective control of broadleaf weeds. It is absorbed through leaves and translocated within plants. Ideal for cereal crops, it improves weed management and crop performance."
  },
  {
    id: 79,
    productName: "HI-TAG",
    technicalName: "Not readable (likely micronutrient / PGR)",
    formulation: "Not visible",
    category: "Fertilizer",
    packSize: "500 ml, 250 ml, 100 ml, 50 ml",
    image: "/images/products/79.jpeg",
    description: "HI-TAG is a liquid fertilizer or plant growth enhancer designed to improve plant nutrition and growth. It supports nutrient uptake, enhances plant vigor, and improves stress tolerance. Suitable for foliar application, it helps promote healthy crop development and yield quality."
  },
  {
    id: 80,
    productName: "VESLA",
    technicalName: "Propiconazole 13.9% + Difenoconazole 13.9%",
    formulation: "EC",
    category: "Fungicide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/80.jpeg",
    description: "VESLA is a combination fungicide containing Propiconazole and Difenoconazole for effective disease management. It offers systemic preventive and curative action against major fungal diseases. The formulation ensures long-lasting protection, healthier plants, and improved crop yields."
  },
  {
    id: 81,
    productName: "CY-10",
    technicalName: "Cypermethrin 10%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/81.jpeg",
    description: "CY-10 is a synthetic pyrethroid insecticide containing Cypermethrin for quick and effective pest control. It works through contact and stomach action against chewing and sucking insects. The formulation provides fast knockdown, extended residual activity, and reliable crop protection."
  },
  {
    id: 82,
    productName: "VITORY",
    technicalName: "Carboxin 37.5% + Thiram 37.5%",
    formulation: "WS",
    category: "Fungicide",
    packSize: "—",
    image: "/images/products/82.jpeg",
    description: "VITORY is a seed treatment fungicide combining Carboxin and Thiram for protection against seed-borne and soil-borne diseases. It improves seed germination, controls smuts and rots, and ensures healthy seedling establishment with long-lasting preventive action."
  },
  {
    id: 83,
    productName: "FILOR-4G",
    technicalName: "Chlorantraniliprole 0.4%",
    formulation: "GR",
    category: "Insecticide",
    packSize: "1 Kg",
    image: "/images/products/83.jpeg",
    description: "FILOR-4G is a granular insecticide containing Chlorantraniliprole for effective control of stem borers and leaf-feeding pests. It provides long-lasting protection by affecting insect muscle function. Ideal for soil application, it ensures strong early-stage crop protection."
  },
  {
    id: 84,
    productName: "KITUPA",
    technicalName: "Cartap Hydrochloride 4% + Fipronil 0.5%",
    formulation: "CG",
    category: "Insecticide",
    packSize: "1 Kg, 500 gm, 250 gm",
    image: "/images/products/84.jpeg",
    description: "KITUPA is a combination granular insecticide formulated with Cartap Hydrochloride and Fipronil. It effectively controls soil and early-stage insect pests through contact and systemic action. The formulation ensures extended residual control and supports healthy crop establishment."
  },
  {
    id: 85,
    productName: "CYKO",
    technicalName: "Cypermethrin 3% + Quinalphos 20%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/85.jpeg",
    description: "CYKO is a combination insecticide containing Cypermethrin and Quinalphos for broad-spectrum pest control. It offers quick knockdown and long residual activity through contact and stomach action. Suitable for various crops, it ensures effective pest management and crop safety."
  },
  {
    id: 86,
    productName: "SIKOVA",
    technicalName: "Lambda Cyhalothrin 10%",
    formulation: "WP",
    category: "Insecticide",
    packSize: "62.5 gm",
    image: "/images/products/86.jpeg",
    description: "SIKOVA is a potent insecticide formulated with Lambda Cyhalothrin for effective control of chewing and sucking pests. It provides fast knockdown through contact action. The wettable powder formulation ensures uniform spray coverage and reliable pest management."
  },
  {
    id: 87,
    productName: "MUNDOR",
    technicalName: "Azoxystrobin 23%",
    formulation: "SC",
    category: "Fungicide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml",
    image: "/images/products/87.jpeg",
    description: "MUNDOR is a systemic fungicide containing Azoxystrobin, effective against a wide range of fungal diseases. It provides preventive and curative action by inhibiting fungal respiration. The formulation promotes healthier plants, improved disease resistance, and higher crop yields."
  },
  {
    id: 88,
    productName: "PILOBA",
    technicalName: "Acephate 50% + Fipronil 5%",
    formulation: "WDG",
    category: "Insecticide",
    packSize: "1 Kg, 500 gm, 250 gm",
    image: "/images/products/88.jpeg",
    description: "PILOBA is a powerful combination insecticide formulated with Acephate and Fipronil for effective pest control. It offers systemic and contact action against major crop pests. The formulation ensures rapid pest reduction, extended protection, and improved crop performance."
  },
  {
    id: 89,
    productName: "PASURI",
    technicalName: "Carbendazim 46.27%",
    formulation: "SC",
    category: "Fungicide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/89.jpeg",
    description: "PASURI is a systemic fungicide containing Carbendazim for effective control of fungal diseases like leaf spots and blights. It offers both preventive and curative action. The formulation improves plant health, disease management, and overall crop productivity."
  },
  {
    id: 90,
    productName: "MUNRO",
    technicalName: "Monocrotophos 36%",
    formulation: "SL",
    category: "Insecticide",
    packSize: "—",
    image: "/images/products/90.jpeg",
    description: "MUNRO is a systemic insecticide formulated with Monocrotophos for effective control of sucking and chewing pests. It provides quick pest knockdown through contact and stomach action. Suitable for various crops, it ensures reliable pest control and reduced crop damage."
  },
  {
    id: 91,
    productName: "DOUBLE-F",
    technicalName: "Novaluron 10%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml",
    image: "/images/products/91.jpeg",
    description: "DOUBLE-F is an insect growth regulator containing Novaluron for controlling caterpillars and larvae. It disrupts insect molting, preventing further development. The formulation ensures long-lasting pest suppression, reduced resistance risk, and improved crop protection."
  },
  {
    id: 92,
    productName: "ONLINE",
    technicalName: "Oxyfluorfen 23.5%",
    formulation: "EC",
    category: "Herbicide",
    packSize: "—",
    image: "/images/products/92.jpeg",
    description: "ONLINE is a selective herbicide containing Oxyfluorfen for effective control of broadleaf and grassy weeds. It works through contact action, inhibiting weed growth. Suitable for pre- and post-emergence application, it helps maintain clean and weed-free fields."
  },
  {
    id: 93,
    productName: "DANGER",
    technicalName: "Indoxacarb 14.5%",
    formulation: "SC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml",
    image: "/images/products/93.jpeg",
    description: "DANGER is a modern insecticide containing Indoxacarb for effective control of lepidopteran pests. It provides stomach and contact action with rapid pest paralysis. Suitable for vegetables and field crops, it ensures reduced crop damage and improved yield quality."
  },
  {
    id: 94,
    productName: "VERAIYA",
    technicalName: "Thiamethoxam 0.9% + Fipronil 0.2%",
    formulation: "GR",
    category: "Insecticide",
    packSize: "—",
    image: "/images/products/94.jpeg",
    description: "VERAIYA is a granular insecticide containing Thiamethoxam and Fipronil for effective control of soil and sucking pests. It provides systemic protection and long residual action. Ideal for soil application, it supports early-stage crop growth and healthy plant development."
  },
  {
    id: 95,
    productName: "PISOTY",
    technicalName: "Cymoxanil 50%",
    formulation: "WP",
    category: "Fungicide",
    packSize: "1 Kg, 500 gm, 250 gm, 100 gm",
    image: "/images/products/95.jpeg",
    description: "PISOTY is a systemic fungicide formulated with Cymoxanil for effective control of fungal diseases like downy mildew. It offers quick curative action and short residual protection. The formulation ensures improved disease management and healthier crop growth."
  },
  {
    id: 96,
    productName: "SAMTARA",
    technicalName: "Sulfentrazone 28% + Clomazone 30%",
    formulation: "WP",
    category: "Herbicide",
    packSize: "1 Kg, 500 gm",
    image: "/images/products/96.jpeg",
    description: "SAMTARA is a selective herbicide combining Sulfentrazone and Clomazone for effective weed control. It controls a wide range of annual weeds through soil and foliar action. Suitable for early application, it supports clean fields and improved crop establishment."
  },
  {
    id: 97,
    productName: "PYDU",
    technicalName: "Emamectin Benzoate 1.5% + Fipronil 3.5%",
    formulation: "SC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml",
    image: "/images/products/97.jpeg",
    description: "PYDU is a combination insecticide containing Emamectin Benzoate and Fipronil for effective control of caterpillars and other pests. It offers stomach and contact action with long residual activity. The formulation ensures strong pest control and improved crop health."
  },
  {
    id: 98,
    productName: "BANOT-D",
    technicalName: "Chlorpyriphos 1.5%",
    formulation: "DP",
    category: "Insecticide",
    packSize: "1 Kg, 500 gm, 250 gm",
    image: "/images/products/98.jpeg",
    description: "BANOT-D is a dust formulation insecticide containing Chlorpyriphos for effective control of soil and storage pests. It works through contact action and provides long-lasting protection. Easy to apply, it helps reduce early-stage pest damage."
  },
  {
    id: 99,
    productName: "EMALA",
    technicalName: "Novaluron 5.25% + Emamectin Benzoate 0.9%",
    formulation: "SC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml",
    image: "/images/products/99.jpeg",
    description: "EMALA is a combination insecticide formulated with Novaluron and Emamectin Benzoate for controlling caterpillars and larvae. It disrupts insect growth and feeding activity. The formulation ensures long-term pest control and improved crop protection."
  },
  {
    id: 100,
    productName: "PAPUAA",
    technicalName: "Tricyclazole 20.4% + Azoxystrobin 6.8%",
    formulation: "SC",
    category: "Fungicide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/100.jpeg",
    description: "PAPUAA is a combination fungicide containing Tricyclazole and Azoxystrobin for effective control of rice blast and other fungal diseases. It offers preventive and curative action. The formulation ensures healthy crop growth, strong disease resistance, and improved yields."
  },
  {
    id: 101,
    productName: "CALTRO",
    technicalName: "Propineb 70%",
    formulation: "WP",
    category: "Fungicide",
    packSize: "1 Kg, 500 gm, 250 gm, 100 gm",
    image: "/images/products/101.jpeg",
    description: "CALTRO is a contact fungicide containing Propineb, effective against a wide range of fungal diseases like leaf spots, blights, and downy mildew. It provides protective action by preventing spore germination. Regular use helps maintain healthy foliage, improved disease resistance, and consistent crop performance."
  },
  {
    id: 102,
    productName: "DOUBLE XTRA",
    technicalName: "Pendimethalin 38.7%",
    formulation: "CS",
    category: "Herbicide",
    packSize: "700 ml, 350 ml",
    image: "/images/products/102.jpeg",
    description: "DOUBLE XTRA is a capsule suspension herbicide formulated with Pendimethalin for pre-emergence weed control. It effectively controls annual grasses and broadleaf weeds by inhibiting seed germination. The formulation ensures uniform soil coverage, reduced weed competition, and better crop establishment."
  },
  {
    id: 103,
    productName: "NARUTO",
    technicalName: "Fenpyroximate 5%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/103.jpeg",
    description: "NARUTO is an acaricide and insecticide containing Fenpyroximate, used for effective control of mites and sucking pests. It works through contact action and disrupts pest respiration. Suitable for vegetables and fruit crops, it ensures rapid pest reduction and healthier plants."
  },
  {
    id: 104,
    productName: "ACTOR",
    technicalName: "Fenoxaprop-P-Ethyl 10%",
    formulation: "EC",
    category: "Herbicide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml",
    image: "/images/products/104.jpeg",
    description: "ACTOR is a selective post-emergence herbicide formulated with Fenoxaprop-P-Ethyl for controlling grassy weeds. It is absorbed through foliage and inhibits weed growth without harming crops. Ideal for cereal crops, it improves weed management and supports higher yields."
  },
  {
    id: 105,
    productName: "TOP STAR",
    technicalName: "Azoxystrobin 18.2% + Difenoconazole 11.4%",
    formulation: "SC",
    category: "Fungicide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml",
    image: "/images/products/105.jpeg",
    description: "TOP STAR is a combination fungicide containing Azoxystrobin and Difenoconazole for broad-spectrum disease control. It provides preventive and curative action against major fungal diseases. The formulation ensures long-lasting protection, healthy foliage, and improved crop productivity."
  },
  {
    id: 106,
    productName: "RIKSHE",
    technicalName: "Novaluron 5.25% + Indoxacarb 4.5%",
    formulation: "SC",
    category: "Insecticide",
    packSize: "—",
    image: "/images/products/106.jpeg",
    description: "RIKSHE is a combination insecticide formulated with Novaluron and Indoxacarb for effective control of caterpillars and larvae. It disrupts insect growth and feeding activity. The formulation provides long-lasting pest suppression and improved crop protection."
  },
  {
    id: 107,
    productName: "KANURI",
    technicalName: "Ziram 27%",
    formulation: "SC",
    category: "Fungicide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/107.jpeg",
    description: "KANURI is a contact fungicide containing Ziram, effective against fungal diseases like leaf spots and blights. It forms a protective layer on plant surfaces to prevent infection. The formulation supports healthy crop growth, improved disease management, and better yield quality."
  },
  {
    id: 108,
    productName: "HALTOR",
    technicalName: "Paclobutrazol 23%",
    formulation: "SC",
    category: "Plant Growth Regulator",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/108.jpeg",
    description: "HALTOR is a plant growth regulator containing Paclobutrazol, used to manage excessive vegetative growth. It enhances flowering, improves root strength, and increases stress tolerance. Suitable for fruit and plantation crops, it helps optimize yield and crop quality."
  },
  {
    id: 109,
    productName: "ALPHAGRO-SC",
    technicalName: "Alphacypermethrin 10%",
    formulation: "SC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml",
    image: "/images/products/109.jpeg",
    description: "ALPHAGRO-SC is a synthetic pyrethroid insecticide containing Alphacypermethrin for fast knockdown of pests. It provides contact and stomach action against chewing and sucking insects. The suspension concentrate formulation ensures effective coverage and long residual protection."
  },
  {
    id: 110,
    productName: "MUKRI",
    technicalName: "Thiophanate Methyl 70%",
    formulation: "WP",
    category: "Fungicide",
    packSize: "1 Kg, 500 gm, 250 gm, 100 gm",
    image: "/images/products/110.jpeg",
    description: "MUKRI is a systemic fungicide containing Thiophanate Methyl, effective against a wide range of fungal diseases. It offers both preventive and curative action by inhibiting fungal growth. The formulation promotes healthy plants, better disease control, and improved yields."
  },
  {
    id: 111,
    productName: "PROCEF SUPER-44",
    technicalName: "Profenofos 40% + Cypermethrin 4%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/111.jpeg",
    description: "PROCEF SUPER-44 is a combination insecticide formulated with Profenofos and Cypermethrin for broad-spectrum pest control. It provides contact and stomach action with quick knockdown. Suitable for multiple crops, it ensures reliable pest management and crop safety."
  },
  {
    id: 112,
    productName: "AAJOBA",
    technicalName: "Azoxystrobin 11.5% + Mancozeb 30%",
    formulation: "WP",
    category: "Fungicide",
    packSize: "1 Kg, 500 gm, 250 gm",
    image: "/images/products/112.jpeg",
    description: "AAJOBA is a combination fungicide containing Azoxystrobin and Mancozeb for effective disease control. It offers systemic and contact action against major fungal infections. The formulation improves plant vigor, disease resistance, and overall crop performance."
  },
  {
    id: 113,
    productName: "HYMAN",
    technicalName: "Quizalofop Ethyl 7.5% + Imazethapyr 15%",
    formulation: "EC",
    category: "Herbicide",
    packSize: "—",
    image: "/images/products/113.jpeg",
    description: "HYMAN is a selective herbicide combining Quizalofop Ethyl and Imazethapyr for effective control of grassy and broadleaf weeds. It is absorbed through foliage and roots, inhibiting weed growth. Suitable for legume crops, it supports clean fields and better yields."
  },
  {
    id: 114,
    productName: "KITOSH",
    technicalName: "Azoxystrobin 11% + Tebuconazole 18.3%",
    formulation: "SC",
    category: "Fungicide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml",
    image: "/images/products/114.jpeg",
    description: "KITOSH is a modern combination fungicide formulated with Azoxystrobin and Tebuconazole. It provides preventive and curative action against a wide range of fungal diseases. The formulation ensures long-lasting disease protection and healthier crop development."
  },
  {
    id: 115,
    productName: "ANT-25",
    technicalName: "Carbosulfan 25%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "—",
    image: "/images/products/115.jpeg",
    description: "ANT-25 is a broad-spectrum insecticide containing Carbosulfan for effective control of soil and foliar pests. It provides systemic and contact action for rapid pest suppression. Suitable for various crops, it ensures improved pest management and crop health."
  },
  {
    id: 116,
    productName: "AK-47",
    technicalName: "Emamectin Benzoate 1.9%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml, 20 ml",
    image: "/images/products/116.jpeg",
    description: "AK-47 is a highly effective insecticide based on Emamectin Benzoate, used for controlling lepidopteran pests. It provides stomach action with rapid pest paralysis. Suitable for vegetables and field crops, it ensures reduced crop damage and improved yield quality."
  },
  {
    id: 117,
    productName: "NLINDA-5",
    technicalName: "Fipronil 5%",
    formulation: "SC",
    category: "Insecticide",
    packSize: "—",
    image: "/images/products/117.jpeg",
    description: "NLINDA-5 is a broad-spectrum insecticide containing Fipronil for effective control of soil and sucking pests. It provides contact and systemic action with long residual effect. The formulation supports strong early-stage crop protection and healthy plant growth."
  },
  {
    id: 118,
    productName: "VOP-75",
    technicalName: "Hexaconazole 75%",
    formulation: "WG",
    category: "Fungicide",
    packSize: "—",
    image: "/images/products/118.jpeg",
    description: "VOP-75 is a systemic fungicide containing Hexaconazole for controlling powdery mildew, rusts, and leaf spots. It offers preventive and curative action by inhibiting fungal growth. The formulation ensures improved disease management and crop productivity."
  },
  {
    id: 119,
    productName: "GAPULA",
    technicalName: "Fipronil 40% + Imidacloprid 40%",
    formulation: "WG",
    category: "Insecticide",
    packSize: "100 gm, 40 gm",
    image: "/images/products/119.jpeg",
    description: "GAPULA is a high-strength combination insecticide formulated with Fipronil and Imidacloprid. It provides strong systemic and contact action against resistant pests. The formulation ensures quick pest control, extended protection, and improved crop safety."
  },
  {
    id: 120,
    productName: "BY-10",
    technicalName: "Bifenthrin 10%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/120.jpeg",
    description: "BY-10 is a synthetic pyrethroid insecticide containing Bifenthrin for fast and effective pest control. It provides contact and stomach action against a wide range of insects. The formulation ensures quick knockdown, residual protection, and healthier crops."
  },
  {
    id: 121,
    productName: "CUTTER",
    technicalName: "Chlorantraniliprole 18.5%",
    formulation: "SC",
    category: "Insecticide",
    packSize: "800 ml, 500 ml, 150 ml, 80 ml, 30 ml",
    image: "/images/products/121.jpeg",
    description: "CUTTER is a modern insecticide containing Chlorantraniliprole for effective control of lepidopteran pests such as borers and caterpillars. It works by disrupting insect muscle function, providing long-lasting protection. The formulation ensures excellent crop safety, reduced pest damage, and improved yield quality."
  },
  {
    id: 122,
    productName: "HAL-80",
    technicalName: "Sulphur 80%",
    formulation: "WDG",
    category: "Fungicide",
    packSize: "—",
    image: "/images/products/122.jpeg",
    description: "HAL-80 is a high-concentration sulphur fungicide in WDG form, effective against powdery mildew and mite infestations. It provides protective action and improves plant resistance. The formulation ensures easy dispersion, uniform coverage, and reliable disease control across crops."
  },
  {
    id: 123,
    productName: "HI-JACK",
    technicalName: "Tricyclazole 75%",
    formulation: "WP",
    category: "Fungicide",
    packSize: "500 gm, 250 gm, 100 gm, 50 gm",
    image: "/images/products/123.jpeg",
    description: "HI-JACK is a systemic fungicide formulated with Tricyclazole for effective control of rice blast disease. It provides preventive and curative action by inhibiting fungal development. The formulation supports healthy crop growth, improved disease resistance, and higher yield potential."
  },
  {
    id: 124,
    productName: "AVERI",
    technicalName: "Bifenthrin 2.5%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 Kg, 500 gm, 250 gm",
    image: "/images/products/124.jpeg",
    description: "AVERI is a synthetic pyrethroid insecticide containing Bifenthrin for fast knockdown of insect pests. It works through contact and stomach action against chewing and sucking insects. Suitable for multiple crops, it provides extended residual protection and improved crop health."
  },
  {
    id: 125,
    productName: "HINDUL",
    technicalName: "Sulfosulfuron 75% + Metsulfuron Methyl 5%",
    formulation: "WG",
    category: "Herbicide",
    packSize: "—",
    image: "/images/products/125.jpeg",
    description: "HINDUL is a selective herbicide combining Sulfosulfuron and Metsulfuron Methyl for effective control of grassy and broadleaf weeds. It is absorbed through foliage and roots, inhibiting weed growth. Ideal for wheat crops, it improves weed management and crop productivity."
  },
  {
    id: 126,
    productName: "KHAJELI",
    technicalName: "Azoxystrobin 4.8% + Chlorothalonil 40%",
    formulation: "SC",
    category: "Fungicide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/126.jpeg",
    description: "KHAJELI is a combination fungicide containing Azoxystrobin and Chlorothalonil for broad-spectrum disease control. It offers systemic and contact action against major fungal diseases. The formulation ensures long-lasting protection, healthier foliage, and improved crop performance."
  },
  {
    id: 127,
    productName: "CAPICON",
    technicalName: "Pyriproxyfen 10% + Bifenthrin 10%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 Kg, 500 gm, 250 gm",
    image: "/images/products/127.jpeg",
    description: "CAPICON is a combination insecticide formulated with Pyriproxyfen and Bifenthrin for effective control of sucking pests. It disrupts insect growth and provides quick knockdown. The formulation ensures extended pest control, reduced resistance risk, and improved crop safety."
  },
  {
    id: 128,
    productName: "SUPER MOX",
    technicalName: "Fipronil 4% + Thiamethoxam 4%",
    formulation: "SC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml, 20 ml",
    image: "/images/products/128.jpeg",
    description: "SUPER MOX is a powerful combination insecticide containing Fipronil and Thiamethoxam for broad-spectrum pest control. It provides systemic and contact action with quick knockdown and long residual effect. Suitable for various crops, it supports healthy plant growth and yield protection."
  },
  {
    id: 129,
    productName: "ABAZIN",
    technicalName: "Abamectin 1.9%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml, 50 ml",
    image: "/images/products/129.jpeg",
    description: "ABAZIN is an avermectin-based insecticide containing Abamectin, effective against mites and leaf-mining pests. It provides stomach and contact action with rapid pest paralysis. Suitable for vegetables and fruit crops, it ensures reduced crop damage and improved quality."
  },
  {
    id: 130,
    productName: "POHIL",
    technicalName: "Dodine 40%",
    formulation: "SC",
    category: "Fungicide",
    packSize: "—",
    image: "/images/products/130.jpeg",
    description: "POHIL is a systemic fungicide containing Dodine for effective control of fungal diseases like scab. It offers both preventive and curative action by inhibiting fungal growth. The formulation ensures strong disease management and healthier crop development."
  },
  {
    id: 131,
    productName: "POPIC",
    technicalName: "Diafenthiuron 50%",
    formulation: "WP",
    category: "Insecticide",
    packSize: "1 Kg, 500 gm, 250 gm, 100 gm",
    image: "/images/products/131.jpeg",
    description: "POPIC is a broad-spectrum insecticide formulated with Diafenthiuron for effective control of resistant sucking pests. It provides contact and systemic action with long residual activity. The formulation ensures rapid pest suppression and improved crop safety."
  },
  {
    id: 132,
    productName: "COVERING",
    technicalName: "Dodine 65%",
    formulation: "WP",
    category: "Fungicide",
    packSize: "1 Kg, 500 gm, 250 gm",
    image: "/images/products/132.jpeg",
    description: "COVERING is a contact fungicide containing Dodine, effective against scab and leaf spot diseases. It forms a protective layer on plant surfaces to prevent infection. The formulation supports consistent disease management and healthy crop growth."
  },
  {
    id: 133,
    productName: "THREE-D",
    technicalName: "Thifluzamide 24%",
    formulation: "SC",
    category: "Fungicide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/133.jpeg",
    description: "THREE-D is a modern fungicide containing Thifluzamide for effective control of soil-borne diseases. It provides long-lasting protection by inhibiting fungal respiration. Suitable for seed and soil application, it supports healthy root development and crop establishment."
  },
  {
    id: 134,
    productName: "HALFAN-DP",
    technicalName: "Fenvalerate 0.4%",
    formulation: "DP",
    category: "Insecticide",
    packSize: "20 Kg, 25 Kg",
    image: "/images/products/134.jpeg",
    description: "HALFAN-DP is a dust formulation insecticide containing Fenvalerate for control of household and field pests. It provides quick knockdown through contact action. Easy to apply, it helps reduce pest infestation and maintain clean crop surroundings."
  },
  {
    id: 135,
    productName: "SUCCESS",
    technicalName: "Fipronil 2.92%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/135.jpeg",
    description: "SUCCESS is a broad-spectrum insecticide formulated with Fipronil for effective control of soil and foliar pests. It provides contact and systemic action with long residual effect. Suitable for multiple crops, it ensures reliable pest management and crop protection."
  },
  {
    id: 136,
    productName: "PYRIN",
    technicalName: "Pyriproxyfen 5% + Diafenthiuron 25%",
    formulation: "SE",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml",
    image: "/images/products/136.jpeg",
    description: "PYRIN is a combination insecticide containing Pyriproxyfen and Diafenthiuron for effective control of sucking pests. It disrupts insect growth and provides systemic protection. The formulation ensures long-lasting pest suppression and improved crop health."
  },
  {
    id: 137,
    productName: "LEENA",
    technicalName: "2,4-D Amine Salt 58%",
    formulation: "SL",
    category: "Herbicide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/137.jpeg",
    description: "LEENA is a systemic herbicide containing 2,4-D Amine Salt for effective control of broadleaf weeds. It is absorbed through leaves and translocated within plants. Suitable for cereal crops, it improves weed management and crop performance."
  },
  {
    id: 138,
    productName: "KETHORA",
    technicalName: "Fenoxaprop-p-ethyl 10%",
    formulation: "EC",
    category: "Herbicide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml",
    image: "/images/products/138.jpeg",
    description: "KETHORA is a selective post-emergence herbicide formulated with Fenoxaprop-p-ethyl for controlling grassy weeds. It is rapidly absorbed through foliage and inhibits weed growth. Ideal for cereal and rice crops, it supports clean fields and higher yields."
  },
  {
    id: 139,
    productName: "OSIKU",
    technicalName: "Dinotefuran 20%",
    formulation: "SG",
    category: "Insecticide",
    packSize: "1 Kg, 500 gm, 250 gm, 100 gm",
    image: "/images/products/139.jpeg",
    description: "OSIKU is a systemic insecticide containing Dinotefuran for effective control of sucking pests. It provides rapid action and long residual protection. The soluble granule formulation ensures easy application, better absorption, and improved crop safety."
  },
  {
    id: 140,
    productName: "DONET",
    technicalName: "Dimethoate 30%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml",
    image: "/images/products/140.jpeg",
    description: "DONET is a systemic organophosphate insecticide containing Dimethoate for effective control of sucking insects. It provides contact and stomach action with quick knockdown. Suitable for various crops, it ensures reliable pest management and reduced crop damage."
  },
  {
    id: 141,
    productName: "PENDORA",
    technicalName: "Tolfenpyrad 15%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/141.jpeg",
    description: "PENDORA is a modern insecticide containing Tolfenpyrad, effective against sucking pests like whiteflies and thrips. It disrupts insect energy production, resulting in rapid pest mortality. The formulation provides quick knockdown, reliable control, and improved crop health across multiple crops."
  },
  {
    id: 142,
    productName: "LUDO-34",
    technicalName: "Tembotrione 34.4%",
    formulation: "SC",
    category: "Herbicide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml",
    image: "/images/products/142.jpeg",
    description: "LUDO-34 is a selective post-emergence herbicide formulated with Tembotrione for effective control of broadleaf and grassy weeds. It inhibits carotenoid biosynthesis, leading to weed bleaching and death. Ideal for maize crops, it ensures clean fields and improved crop establishment."
  },
  {
    id: 143,
    productName: "COFFEE-30",
    technicalName: "Imidacloprid 30.5%",
    formulation: "SC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml, 50 ml",
    image: "/images/products/143.jpeg",
    description: "COFFEE-30 is a systemic insecticide containing Imidacloprid for effective control of sucking pests. It is rapidly absorbed and translocated within plants, providing long-lasting protection. Suitable for multiple crops, it helps maintain pest-free fields and healthier plant growth."
  },
  {
    id: 144,
    productName: "METRO-2",
    technicalName: "Mesotrione 2.27% + Atrazine 22.7%",
    formulation: "SC",
    category: "Herbicide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/144.jpeg",
    description: "METRO-2 is a combination herbicide formulated with Mesotrione and Atrazine for broad-spectrum weed control. It effectively manages grasses and broadleaf weeds through systemic and residual action. Suitable for maize cultivation, it reduces weed competition and improves yield potential."
  },
  {
    id: 145,
    productName: "HELLO-20",
    technicalName: "Metsulfuron Methyl 20%",
    formulation: "WP",
    category: "Herbicide",
    packSize: "3 gm",
    image: "/images/products/145.jpeg",
    description: "HELLO-20 is a selective herbicide containing Metsulfuron Methyl for effective control of broadleaf weeds. It is active at very low doses and absorbed through foliage and roots. Ideal for cereal crops, it improves weed management and supports better crop growth."
  },
  {
    id: 146,
    productName: "KINDA",
    technicalName: "Metalaxyl-M 3.3% + Chlorothalonil 33.1%",
    formulation: "SC",
    category: "Fungicide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/146.jpeg",
    description: "KINDA is a combination fungicide containing Metalaxyl-M and Chlorothalonil for effective control of fungal diseases. It offers systemic and contact action, providing both preventive and curative protection. The formulation ensures strong disease management and healthier crop development."
  },
  {
    id: 147,
    productName: "EKTA-75",
    technicalName: "Thiamethoxam 75%",
    formulation: "SG",
    category: "Insecticide",
    packSize: "1 Kg, 500 gm, 250 gm, 100 gm, 50 gm",
    image: "/images/products/147.jpeg",
    description: "EKTA-75 is a highly concentrated systemic insecticide formulated with Thiamethoxam. It provides effective control of sucking pests through rapid absorption and translocation. The soluble granule formulation ensures easy application, long residual activity, and reliable crop protection."
  },
  {
    id: 148,
    productName: "PESTON",
    technicalName: "Pyriproxyfen 8% + Dinotefuran 5% + Diafenthiuron 18%",
    formulation: "SC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml, 50 ml",
    image: "/images/products/148.jpeg",
    description: "PESTON is a powerful combination insecticide containing Pyriproxyfen, Dinotefuran, and Diafenthiuron. It provides multiple modes of action for effective control of resistant sucking pests. The formulation ensures long-lasting pest suppression, reduced resistance risk, and improved crop health."
  },
  {
    id: 149,
    productName: "HYTHEN",
    technicalName: "Ethephon 39%",
    formulation: "SL",
    category: "Plant Growth Regulator",
    packSize: "100 ml",
    image: "/images/products/149.jpeg",
    description: "HYTHEN is a plant growth regulator containing Ethephon, used to promote uniform ripening and flowering. It releases ethylene to regulate plant physiological processes. Suitable for horticultural crops, it improves maturity synchronization and overall crop quality."
  },
  {
    id: 150,
    productName: "ARAVAN",
    technicalName: "Pymetrozine 50%",
    formulation: "WG",
    category: "Insecticide",
    packSize: "1 Kg, 500 gm, 250 gm, 120 gm",
    image: "/images/products/150.jpeg",
    description: "ARAVAN is a selective insecticide formulated with Pymetrozine for effective control of aphids and whiteflies. It disrupts insect feeding behavior, leading to rapid pest suppression. The formulation ensures targeted pest control with minimal impact on beneficial insects."
  },
  {
    id: 151,
    productName: "KODIYA",
    technicalName: "Azoxystrobin 11% + Tebuconazole 18.3%",
    formulation: "SC",
    category: "Fungicide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml",
    image: "/images/products/151.jpeg",
    description: "KODIYA is a combination fungicide containing Azoxystrobin and Tebuconazole for broad-spectrum disease control. It offers preventive and curative action against major fungal diseases. The formulation ensures long-lasting protection, healthy foliage, and improved crop yields."
  },
  {
    id: 152,
    productName: "GA-186",
    technicalName: "Gibberellic Acid 0.186%",
    formulation: "SP",
    category: "Plant Growth Regulator",
    packSize: "—",
    image: "/images/products/152.jpeg",
    description: "GA-186 is a plant growth regulator containing Gibberellic Acid, used to promote cell elongation and plant growth. It enhances flowering, fruit development, and overall plant vigor. Suitable for various crops, it helps improve yield quality and uniformity."
  },
  {
    id: 153,
    productName: "HYSER",
    technicalName: "Carbendazim 12% + Mancozeb 63%",
    formulation: "WP",
    category: "Fungicide",
    packSize: "1 Kg, 500 gm, 250 gm, 100 gm",
    image: "/images/products/153.jpeg",
    description: "HYSER is a combination fungicide formulated with Carbendazim and Mancozeb for effective disease control. It provides systemic and contact action against major fungal diseases. The formulation supports strong disease management and healthier crop growth."
  },
  {
    id: 154,
    productName: "TEJUL",
    technicalName: "Triacontanol EW 0.1%",
    formulation: "EW",
    category: "Plant Growth Regulator",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/154.jpeg",
    description: "TEJUL is a plant growth regulator containing Triacontanol, designed to enhance photosynthesis and plant metabolism. It improves root growth, flowering, and yield potential. Suitable for foliar application, it supports healthy plant development and stress tolerance."
  },
  {
    id: 155,
    productName: "GLOREE-50",
    technicalName: "Chlorpyrifos 50%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/155.jpeg",
    description: "GLOREE-50 is a broad-spectrum insecticide containing Chlorpyrifos for effective control of soil and foliar pests. It provides contact and stomach action with quick knockdown. Suitable for multiple crops, it ensures reliable pest management and crop safety."
  },
  {
    id: 156,
    productName: "GA-48",
    technicalName: "Imidacloprid 48%",
    formulation: "FS",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml",
    image: "/images/products/156.jpeg",
    description: "GA-48 is a seed treatment insecticide formulated with Imidacloprid for protection against early-stage pests. It provides systemic action, improving seedling vigor and pest resistance. The formulation ensures healthy crop establishment and long-lasting protection."
  },
  {
    id: 157,
    productName: "FINZO-25",
    technicalName: "Tebuconazole 25.9%",
    formulation: "EC",
    category: "Fungicide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml",
    image: "/images/products/157.jpeg",
    description: "FINZO-25 is a systemic fungicide containing Tebuconazole for effective control of rusts, leaf spots, and powdery mildew. It offers preventive and curative action. The formulation promotes healthy foliage and improved crop productivity."
  },
  {
    id: 158,
    productName: "FIGHTER JET-55",
    technicalName: "Chlorpyriphos 50% + Cypermethrin 5%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/158.jpeg",
    description: "FIGHTER JET-55 is a combination insecticide containing Chlorpyriphos and Cypermethrin for broad-spectrum pest control. It provides quick knockdown and long residual action. Suitable for various crops, it ensures effective pest management and yield protection."
  },
  {
    id: 159,
    productName: "HY-45",
    technicalName: "Mancozeb 75%",
    formulation: "WP",
    category: "Fungicide",
    packSize: "1 Kg, 500 gm, 250 gm",
    image: "/images/products/159.jpeg",
    description: "HY-45 is a contact fungicide formulated with Mancozeb for protection against fungal diseases. It prevents spore germination and spread of infection. Regular application helps maintain healthy crops, improved disease resistance, and stable yield performance."
  },
  {
    id: 160,
    productName: "EBOLA",
    technicalName: "Emamectin Benzoate 3% + Thiamethoxam 12%",
    formulation: "WG",
    category: "Insecticide",
    packSize: "500 gm, 250 gm, 100 gm",
    image: "/images/products/160.jpeg",
    description: "EBOLA is a combination insecticide containing Emamectin Benzoate and Thiamethoxam for effective control of caterpillars and sucking pests. It provides stomach and systemic action with rapid pest control. The formulation ensures long-lasting protection and improved crop health."
  },
  {
    id: 161,
    productName: "AMINO GOLD",
    technicalName: "Humic Acid 15% + Amino Acid 10%",
    formulation: "Liquid",
    category: "Fertilizer",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/161.jpeg",
    description: "AMINO GOLD is a liquid fertilizer enriched with humic acid and amino acids to improve soil fertility and plant nutrition. It enhances nutrient uptake, root development, and stress tolerance. Regular use promotes healthy plant growth, better flowering, and improved yield quality across crops."
  },
  {
    id: 162,
    productName: "Ekta-25",
    technicalName: "Thiamethoxam 25%",
    formulation: "WG",
    category: "Insecticide",
    packSize: "500 gm, 250 gm, 100 gm",
    image: "/images/products/162.jpeg",
    description: "Ekta-25 is a systemic insecticide containing Thiamethoxam for effective control of sucking pests. It is rapidly absorbed and translocated within plants, providing long-lasting protection. The water-dispersible granule formulation ensures easy application and consistent pest management."
  },
  {
    id: 163,
    productName: "MOSIBA",
    technicalName: "Buprofezin 15% + Acephate 35%",
    formulation: "WP",
    category: "Insecticide",
    packSize: "1 Kg, 500 gm, 250 gm, 100 gm",
    image: "/images/products/163.jpeg",
    description: "MOSIBA is a combination insecticide formulated with Buprofezin and Acephate for effective control of sucking pests. It provides systemic and contact action, disrupting pest growth and feeding. The formulation ensures long-term pest suppression and healthier crop development."
  },
  {
    id: 164,
    productName: "S-GUARD",
    technicalName: "Acephate 50% + Imidacloprid 1.8%",
    formulation: "SP",
    category: "Insecticide",
    packSize: "1 Kg, 500 gm, 250 gm, 100 gm",
    image: "/images/products/164.jpeg",
    description: "S-GUARD is a combination insecticide containing Acephate and Imidacloprid for broad-spectrum pest control. It offers systemic and contact action against sucking and chewing insects. The soluble powder formulation ensures quick absorption, reliable control, and improved crop safety."
  },
  {
    id: 165,
    productName: "HINDUSTAN-6G",
    technicalName: "Carbosulfan 6%",
    formulation: "G",
    category: "Insecticide",
    packSize: "3 Kg, 1 Kg",
    image: "/images/products/165.jpeg",
    description: "HINDUSTAN-6G is a granular insecticide formulated with Carbosulfan for effective control of soil-dwelling pests. It provides systemic action and long residual protection. Ideal for early crop stages, it helps reduce pest damage and supports healthy crop establishment."
  },
  {
    id: 166,
    productName: "MI-71",
    technicalName: "Ammonium Salt of Glyphosate 71%",
    formulation: "SG",
    category: "Herbicide",
    packSize: "200 gm",
    image: "/images/products/166.jpeg",
    description: "MI-71 is a non-selective systemic herbicide containing high-strength glyphosate ammonium salt. It effectively controls annual and perennial weeds by inhibiting plant growth processes. Suitable for pre-planting and non-crop areas, it ensures clean fields and reduced weed competition."
  },
  {
    id: 167,
    productName: "GLOREE-20",
    technicalName: "Chlorpyriphos 20%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/167.jpeg",
    description: "GLOREE-20 is a broad-spectrum insecticide formulated with Chlorpyriphos for effective pest control. It works through contact and stomach action, providing quick knockdown. Suitable for multiple crops, it helps manage pest infestations and protect crop yield."
  },
  {
    id: 168,
    productName: "LORIBA",
    technicalName: "Imidacloprid 6% + Lambda Cyhalothrin 4%",
    formulation: "SL",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/168.jpeg",
    description: "LORIBA is a combination insecticide containing Imidacloprid and Lambda Cyhalothrin for effective control of sucking and chewing pests. It provides systemic and contact action with rapid knockdown and long residual effect, ensuring healthy crop growth and improved productivity."
  },
  {
    id: 169,
    productName: "OLIMBA",
    technicalName: "Azoxystrobin 2.5% + Thiophanate Methyl 11.25% + Thiamethoxam 25%",
    formulation: "FS",
    category: "Insecticide",
    packSize: "—",
    image: "/images/products/169.jpeg",
    description: "OLIMBA is a multi-action seed treatment formulation combining fungicide and insecticide components. It protects seeds and seedlings from early-stage pests and diseases. The formulation ensures better germination, strong seedling vigor, and improved crop establishment."
  },
  {
    id: 170,
    productName: "KONA",
    technicalName: "Fenoxaprop-P-ethyl 10%",
    formulation: "EC",
    category: "Herbicide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml",
    image: "/images/products/170.jpeg",
    description: "KONA is a selective post-emergence herbicide formulated with Fenoxaprop-P-ethyl for controlling grassy weeds. It is absorbed through foliage and inhibits weed growth. Suitable for cereal and rice crops, it helps maintain clean fields and higher yields."
  },
  {
    id: 171,
    productName: "HAITER",
    technicalName: "Captan 70% + Hexaconazole 5%",
    formulation: "WP",
    category: "Fungicide",
    packSize: "1 Kg, 500 gm, 250 gm, 100 gm",
    image: "/images/products/171.jpeg",
    description: "HAITER is a combination fungicide containing Captan and Hexaconazole for effective disease control. It provides contact and systemic action against fungal infections. The formulation ensures broad-spectrum protection, healthier foliage, and improved crop performance."
  },
  // {
  //   id: 172,
  //   productName: "NIMU GOLD",
  //   technicalName: "Bispyribac Sodium 10%",
  //   formulation: "SC",
  //   category: "Herbicide",
  //   packSize: "1 L, 500 ml, 250 ml, 100 ml",
  //   image: "/images/products/172.jpeg",
  //   description: "NIMU GOLD is a selective herbicide formulated with Bispyribac Sodium for effective control of grassy weeds. It is absorbed through foliage and translocated within plants. Ideal for rice cultivation, it supports clean fields and improved crop yield."
  // },
  {
    id: 173,
    productName: "OKIA",
    technicalName: "Emamectin Benzoate 5%",
    formulation: "SG",
    category: "Insecticide",
    packSize: "1 Kg, 500 gm, 250 gm, 100 gm, 50 gm",
    image: "/images/products/173.jpeg",
    description: "OKIA is a potent insecticide containing Emamectin Benzoate for effective control of caterpillars and lepidopteran pests. It provides stomach action with rapid pest paralysis. The soluble granule formulation ensures easy application and long-lasting crop protection."
  },
  {
    id: 174,
    productName: "OTIS",
    technicalName: "Quizalofop Ethyl 10%",
    formulation: "EC",
    category: "Herbicide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml",
    image: "/images/products/174.jpeg",
    description: "OTIS is a selective herbicide containing Quizalofop Ethyl for controlling grassy weeds. It is absorbed through foliage and inhibits weed growth. Suitable for oilseed and pulse crops, it improves weed management and crop productivity."
  },
  {
    id: 175,
    productName: "SUPER DHAMAL",
    technicalName: "Amino Acid 45% + Fulvic Acid 25%",
    formulation: "SL",
    category: "Plant Growth Regulator",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/175.jpeg",
    description: "SUPER DHAMAL is a plant growth regulator enriched with amino acids and fulvic acid. It enhances nutrient absorption, improves plant metabolism, and increases stress tolerance. Regular application promotes vigorous growth, better flowering, and improved yield quality."
  },
  {
    id: 176,
    productName: "KUNUSH-50",
    technicalName: "Copper Oxychloride 50%",
    formulation: "WP",
    category: "Fungicide",
    packSize: "1 Kg, 500 gm, 250 gm",
    image: "/images/products/176.jpeg",
    description: "KUNUSH-50 is a contact fungicide formulated with Copper Oxychloride for effective control of fungal and bacterial diseases. It provides protective action by preventing spore germination. Suitable for multiple crops, it ensures healthy plants and improved disease resistance."
  },
  {
    id: 177,
    productName: "KING",
    technicalName: "Acephate 75%",
    formulation: "SP",
    category: "Insecticide",
    packSize: "1 Kg, 500 gm, 250 gm, 100 gm",
    image: "/images/products/177.jpeg",
    description: "KING is a systemic insecticide containing Acephate for effective control of sucking and chewing pests. It provides contact and stomach action with rapid absorption. The soluble powder formulation ensures consistent pest control and improved crop health."
  },
  {
    id: 178,
    productName: "ATAVA",
    technicalName: "Azoxystrobin 16.7% + Tricyclazole 33.3%",
    formulation: "SC",
    category: "Fungicide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml",
    image: "/images/products/178.jpeg",
    description: "ATAVA is a combination fungicide formulated with Azoxystrobin and Tricyclazole for effective control of rice blast and other fungal diseases. It offers preventive and curative action, supporting healthy crop growth and improved yield potential."
  },
  {
    id: 179,
    productName: "TANO-G",
    technicalName: "Tricyclazole 18% + Mancozeb 62%",
    formulation: "WP",
    category: "Fungicide",
    packSize: "1 Kg, 500 gm, 250 gm, 100 gm, 50 gm",
    image: "/images/products/179.jpeg",
    description: "TANO-G is a combination fungicide containing Tricyclazole and Mancozeb for broad-spectrum disease control. It provides systemic and contact action against major fungal diseases. The formulation ensures strong disease protection and healthier crops."
  },
  {
    id: 180,
    productName: "MENTAKI",
    technicalName: "Metalaxyl 35%",
    formulation: "WS",
    category: "Fungicide",
    packSize: "1 Kg, 500 gm, 250 gm, 100 gm",
    image: "/images/products/180.jpeg",
    description: "MENTAKI is a seed treatment fungicide formulated with Metalaxyl for effective control of seed-borne and soil-borne diseases. It improves seed germination, protects seedlings, and ensures healthy early-stage crop establishment."
  },
  {
    id: 181,
    productName: "V-32",
    technicalName: "Pendimethalin 30% + Imazethapyr 2%",
    formulation: "EC",
    category: "Herbicide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/181.jpeg",
    description: "V-32 is a combination herbicide containing Pendimethalin and Imazethapyr for effective pre-emergence and early post-emergence weed control. It controls grassy and broadleaf weeds by inhibiting germination and growth. Suitable for soybean and pulse crops, it ensures clean fields and better crop establishment."
  },
  {
    id: 182,
    productName: "GENTEL",
    technicalName: "Thiram 75%",
    formulation: "WS",
    category: "Fungicide",
    packSize: "1 Kg, 500 gm, 250 gm, 100 gm",
    image: "/images/products/182.jpeg",
    description: "GENTEL is a seed treatment fungicide formulated with Thiram for protection against seed-borne and soil-borne diseases. It improves seed germination, prevents damping-off, and protects seedlings during early growth stages, ensuring healthy crop establishment and uniform plant stand."
  },
  {
    id: 183,
    productName: "NIMBODI",
    technicalName: "Azadirachtin 0.03% (Neem Oil Based)",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/183.jpeg",
    description: "NIMBODI is a neem-based botanical insecticide containing Azadirachtin, used for eco-friendly pest control. It acts as an insect growth regulator and feeding deterrent. Ideal for IPM programs, it helps manage pests while maintaining environmental safety and crop health."
  },
  {
    id: 184,
    productName: "HY-CEL",
    technicalName: "Glyphosate 41%",
    formulation: "SL",
    category: "Herbicide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/184.jpeg",
    description: "HY-CEL is a non-selective systemic herbicide containing Glyphosate for broad-spectrum weed control. It effectively controls annual and perennial weeds by translocating throughout the plant. Suitable for non-crop areas and pre-plant use, it helps maintain clean and weed-free fields."
  },
  {
    id: 185,
    productName: "KRISH",
    technicalName: "Novaluron 5.25% + Indoxacarb 4.5%",
    formulation: "SC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml, 50 ml",
    image: "/images/products/185.jpeg",
    description: "KRISH is a combination insecticide formulated with Novaluron and Indoxacarb for effective control of caterpillars and larvae. It disrupts insect growth and feeding behavior, providing long-lasting pest suppression and improved crop protection across various crops."
  },
  {
    id: 186,
    productName: "PROMA",
    technicalName: "Emamectin Benzoate 5%",
    formulation: "SG",
    category: "Insecticide",
    packSize: "1 Kg, 500 gm, 250 gm, 100 gm, 50 gm",
    image: "/images/products/186.jpeg",
    description: "PROMA is a potent insecticide containing Emamectin Benzoate for control of lepidopteran pests. It provides stomach action with rapid pest paralysis. The soluble granule formulation ensures easy application, effective pest control, and reduced crop damage."
  },
  {
    id: 187,
    productName: "SINECAS",
    technicalName: "Lambda-cyhalothrin 4.9%",
    formulation: "CS",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/187.jpeg",
    description: "SINECAS is a capsule suspension insecticide containing Lambda-cyhalothrin for fast and effective pest control. It provides quick knockdown and residual action against chewing and sucking insects. The advanced formulation ensures better stability and improved crop safety."
  },
  {
    id: 188,
    productName: "SUPER-40",
    technicalName: "Sulphur 40%",
    formulation: "SC",
    category: "Fungicide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/188.jpeg",
    description: "SUPER-40 is a sulphur-based fungicide effective against powdery mildew and mite infestations. It provides protective action and enhances plant resistance. The suspension concentrate formulation ensures uniform spray coverage and reliable disease management in multiple crops."
  },
  {
    id: 189,
    productName: "SIJE-3",
    technicalName: "Carbofuran 3%",
    formulation: "CG",
    category: "Insecticide",
    packSize: "3 Kg, 1 Kg",
    image: "/images/products/189.jpeg",
    description: "SIJE-3 is a granular insecticide formulated with Carbofuran for effective control of soil-dwelling pests. It provides systemic protection during early crop stages. Suitable for soil application, it helps reduce pest damage and supports healthy crop establishment."
  },
  {
    id: 190,
    productName: "CY-25",
    technicalName: "Cypermethrin 25%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/190.jpeg",
    description: "CY-25 is a synthetic pyrethroid insecticide containing Cypermethrin for strong and fast pest control. It works through contact and stomach action against a wide range of insects. The formulation provides quick knockdown and extended residual protection."
  },
  {
    id: 191,
    productName: "VEJITA-3",
    technicalName: "Validamycin 3%",
    formulation: "L",
    category: "Fungicide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/191.jpeg",
    description: "VEJITA-3 is an antibiotic fungicide containing Validamycin for control of sheath blight and soil-borne diseases. It inhibits fungal growth and spread. Suitable for rice and other crops, it helps maintain healthy plants and improved yield potential."
  },
  {
    id: 192,
    productName: "TOP-EC",
    technicalName: "Hexaconazole 5%",
    formulation: "EC",
    category: "Fungicide",
    packSize: "—",
    image: "/images/products/192.jpeg",
    description: "TOP-EC is a systemic fungicide formulated with Hexaconazole for effective control of powdery mildew, rusts, and leaf spot diseases. It offers preventive and curative action by inhibiting fungal growth, ensuring healthier foliage and better crop productivity."
  },
  {
    id: 193,
    productName: "PERAGOM-24",
    technicalName: "Paraquat Dichloride 24%",
    formulation: "SL",
    category: "Herbicide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/193.jpeg",
    description: "PERAGOM-24 is a fast-acting contact herbicide containing Paraquat Dichloride for quick weed control. It effectively controls green foliage by disrupting plant cell membranes. Suitable for non-crop areas and inter-row spaces, it helps maintain clean fields."
  },
  {
    id: 194,
    productName: "SUPER-T",
    technicalName: "Quizalofop-ethyl 5%",
    formulation: "EC",
    category: "Herbicide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/194.jpeg",
    description: "SUPER-T is a selective post-emergence herbicide containing Quizalofop-ethyl for effective control of grassy weeds. It is absorbed through foliage and inhibits weed growth without harming crops, supporting improved crop establishment and yield."
  },
  {
    id: 195,
    productName: "TEMBU",
    technicalName: "Tebuconazole 38.39%",
    formulation: "SC",
    category: "Fungicide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml",
    image: "/images/products/195.jpeg",
    description: "TEMBU is a systemic fungicide containing Tebuconazole for control of rusts, leaf spots, and powdery mildew. It offers preventive and curative action with long residual effect, promoting healthy crop growth and improved disease resistance."
  },
  {
    id: 196,
    productName: "LAMBO",
    technicalName: "Lambda-cyhalothrin 5%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/196.jpeg",
    description: "LAMBO is a pyrethroid insecticide formulated with Lambda-cyhalothrin for rapid pest knockdown. It provides contact and stomach action against chewing and sucking insects. Suitable for various crops, it ensures reliable pest management and crop safety."
  },
  {
    id: 197,
    productName: "MOOAN",
    technicalName: "Ethion 50%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/197.jpeg",
    description: "MOOAN is a broad-spectrum organophosphate insecticide containing Ethion for control of mites and insect pests. It works through contact and stomach action, providing effective pest reduction and protecting crop yield."
  },
  {
    id: 198,
    productName: "HYPER",
    technicalName: "Acetamiprid 20%",
    formulation: "SP",
    category: "Insecticide",
    packSize: "500 gm, 250 gm, 100 gm",
    image: "/images/products/198.jpeg",
    description: "HYPER is a systemic insecticide containing Acetamiprid for effective control of sucking pests. It is quickly absorbed and translocated within plants, providing long-lasting protection. The soluble powder formulation ensures easy application and consistent pest control."
  },
  {
    id: 199,
    productName: "VERKA",
    technicalName: "Hexaconazole 4% + Carbendazim 16%",
    formulation: "SC",
    category: "Fungicide",
    packSize: "—",
    image: "/images/products/199.jpeg",
    description: "VERKA is a combination fungicide formulated with Hexaconazole and Carbendazim for broad-spectrum disease control. It offers systemic action against major fungal diseases, ensuring improved plant health, disease resistance, and stable yields."
  },
  {
    id: 200,
    productName: "RAYO-FS",
    technicalName: "Thiamethoxam 30%",
    formulation: "FS",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/200.jpeg",
    description: "RAYO-FS is a seed treatment insecticide containing Thiamethoxam for protection against early-stage pests. It provides systemic action, improves seedling vigor, and ensures healthy crop establishment with long-lasting pest protection."
  },
  {
    id: 201,
    productName: "BARIK",
    technicalName: "Lambda-cyhalothrin 2.5%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/201.jpeg",
    description: "BARIK is a synthetic pyrethroid insecticide containing Lambda-cyhalothrin for quick and effective pest control. It offers contact and stomach action with rapid knockdown, helping maintain pest-free crops and improved yield performance."
  },
  {
    id: 202,
    productName: "HI-TAG",
    technicalName: "Amino Acids & Vitamins",
    formulation: "SL",
    category: "Plant Growth Regulator",
    packSize: "500 ml, 250 ml, 100 ml, 50 ml",
    image: "/images/products/202.jpeg",
    description: "HI-TAG is a plant growth regulator enriched with amino acids and vitamins to enhance plant metabolism and nutrient uptake. It improves growth, stress tolerance, and overall crop vigor. Suitable for foliar application, it supports better yield quality."
  },
  {
    id: 203,
    productName: "URIK",
    technicalName: "Triflumezopyrim 10%",
    formulation: "SC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml, 100 ml",
    image: "/images/products/203.jpeg",
    description: "URIK is a modern insecticide containing Triflumezopyrim for effective control of planthoppers and sucking pests. It disrupts insect feeding behavior, providing targeted pest control with minimal impact on beneficial insects and improved crop safety."
  },
  {
    id: 204,
    productName: "DORTON",
    technicalName: "Ethion 40% + Cypermethrin 5%",
    formulation: "EC",
    category: "Insecticide",
    packSize: "1 L, 500 ml, 250 ml",
    image: "/images/products/204.jpeg",
    description: "DORTON is a combination insecticide formulated with Ethion and Cypermethrin for broad-spectrum pest control. It provides quick knockdown and residual action through contact and stomach effects, ensuring reliable pest management and crop protection."
  },
  {
    id: 205,
    productName: "OLIMBA",
    technicalName: "Azoxystrobin 2.5% + Thiophanate Methyl 11.25% + Thiamethoxam 25%",
    formulation: "FS",
    category: "Fungicide",
    packSize: "—",
    image: "/images/products/169.jpeg",
    description: "OLIMBA is a multi-action seed treatment formulation combining fungicide and insecticide components. It protects seeds and seedlings from early-stage pests and diseases. The formulation ensures better germination, strong seedling vigor, and improved crop establishment."
  },
  {
    id: 206,
    productName: "UTSAV NPK 13:40:13",
    technicalName: "Nitrogen 13% + Phosphorus 40% + Potassium 13%",
    formulation: "Water Soluble Powder",
    category: "NPK Fertilizer",
    packSize: "1 Kg",
    image: "/images/products/205.jpg",
    description: "UTSAV NPK 13:40:13 is a phosphorus-rich water soluble fertilizer ideal for early growth and flowering stages. It promotes strong root development, enhances energy transfer, improves flowering, and ensures balanced crop nutrition for better establishment."
  },
  {
    id: 207,
    productName: "UTSAV NPK 00:00:50",
    technicalName: "Potassium Sulphate (SOP)",
    formulation: "Water Soluble Powder",
    category: "NPK Fertilizer",
    packSize: "1 Kg",
    image: "/images/products/206.jpg",
    description: "UTSAV NPK 00:00:50 is a potassium-rich fertilizer supplying 50% soluble potash along with sulphur. It enhances fruit size, color, sweetness, improves stress tolerance, and supports better crop quality and yield."
  },
  {
    id: 208,
    productName: "UTSAV NPK 12:61:00",
    technicalName: "Mono Ammonium Phosphate (MAP)",
    formulation: "Water Soluble Powder",
    category: "NPK Fertilizer",
    packSize: "1 Kg",
    image: "/images/products/207.jpg",
    description: "UTSAV NPK 12:61:00 is a high-phosphorus fertilizer ideal for root development and early crop growth. It supports flowering, improves nutrient absorption, and is suitable for fertigation and foliar applications."
  },
  {
    id: 209,
    productName: "UTSAV NPK 00:52:34",
    technicalName: "Mono Potassium Phosphate (MKP)",
    formulation: "Water Soluble Powder",
    category: "NPK Fertilizer",
    packSize: "1 Kg",
    image: "/images/products/208.jpg",
    description: "UTSAV NPK 00:52:34 is a nitrogen-free fertilizer rich in phosphorus and potassium. It promotes strong root growth, improves flowering and fruit setting, and enhances crop quality during critical growth stages."
  },
  {
    id: 210,
    productName: "UTSAV NPK 19:19:19",
    technicalName: "Nitrogen 19% + Phosphorus 19% + Potassium 19%",
    formulation: "Water Soluble Powder",
    category: "NPK Fertilizer",
    packSize: "1 Kg",
    image: "/images/products/209.jpg",
    description: "UTSAV NPK 19:19:19 is a balanced water soluble fertilizer suitable for all crop stages. It supports vegetative growth, flowering, fruit development, and improves overall crop vigor and productivity."
  },
  {
    id: 211,
    productName: "UTSAV NPK 20:20:20",
    technicalName: "Nitrogen 20% + Phosphorus 20% + Potassium 20%",
    formulation: "Water Soluble Powder",
    category: "NPK Fertilizer",
    packSize: "1 Kg",
    image: "/images/products/210.jpg",
    description: "UTSAV NPK 20:20:20 provides balanced nutrition for uniform crop growth. It enhances vegetative and reproductive development, improves flowering, fruiting, and ensures better yield and crop quality."
  },
  {
    id: 212,
    productName: "UTSAV Calcium Nitrate",
    technicalName: "Calcium Nitrate",
    formulation: "Water Soluble Granules",
    category: "NPK Fertilizer",
    packSize: "1 Kg",
    image: "/images/products/211.jpg",
    description: "UTSAV Calcium Nitrate supplies readily available calcium and nitrogen. It strengthens cell walls, prevents fruit cracking and blossom end rot, improves shelf life, and enhances overall plant health."
  },
  {
    id: 213,
    productName: "UTSAV Magnesium Sulphate",
    technicalName: "Magnesium Sulphate",
    formulation: "Water Soluble Powder",
    category: "NPK Fertilizer",
    packSize: "1 Kg",
    image: "/images/products/212.jpg",
    description: "UTSAV Magnesium Sulphate corrects magnesium deficiency and supports chlorophyll formation. It enhances photosynthesis, improves leaf color, and increases crop yield and quality."
  },
  {
    id: 214,
    productName: "UTSAV Zinc Sulphate 21%",
    technicalName: "Zinc Sulphate Heptahydrate",
    formulation: "Crystalline Powder",
    category: "NPK Fertilizer",
    packSize: "1 Kg",
    image: "/images/products/213.jpg",
    description: "UTSAV Zinc Sulphate 21% Heptahydrate corrects zinc deficiency and supports enzyme activation and hormone balance. It improves leaf growth, flowering, grain development, and overall crop productivity."
  },
  {
    id: 215,
    productName: "UTSAV NPK 17:44:00",
    technicalName: "Urea Phosphate",
    formulation: "Water Soluble Powder",
    category: "NPK Fertilizer",
    packSize: "1 Kg",
    image: "/images/products/214.jpg",
    description: "UTSAV NPK 17:44:00 is a highly efficient phosphorus-rich fertilizer suitable for early growth and flowering stages. It improves root development, enhances nutrient uptake, and supports strong crop establishment."
  },
  {
    id: 216,
    productName: "UTSAV NPK 13:40:13",
    technicalName: "Nitrogen 13% + Phosphorus 40% + Potassium 13%",
    formulation: "Water Soluble Powder",
    category: "NPK Fertilizer",
    packSize: "1 Kg",
    image: "/images/products/215.jpg",
    description: "UTSAV NPK 13:40:13 is a phosphorus-rich water soluble fertilizer ideal for early growth stages. It promotes strong root development, enhances flowering, and improves nutrient uptake for better crop establishment."
  },
  {
    id: 217,
    productName: "UTSAV Sulphur 90 Granular",
    technicalName: "Elemental Sulphur 90%",
    formulation: "Granular",
    category: "NPK Fertilizer",
    packSize: "1 Kg",
    image: "/images/products/216.jpg",
    description: "UTSAV Sulphur 90 Granular corrects sulphur deficiency and improves soil health. It enhances nitrogen and phosphorus uptake, increases oil content, and improves crop quality with long-lasting sulphur availability."
  },
  {
    id: 218,
    productName: "UTSAV Calcium Nitrate with Boron",
    technicalName: "Calcium Nitrate + Boron",
    formulation: "Water Soluble Granules",
    category: "NPK Fertilizer",
    packSize: "1 Kg",
    image: "/images/products/217.jpg",
    description: "UTSAV Calcium Nitrate with Boron supplies calcium, nitrogen, and boron for stronger cell walls and improved fruit quality. It prevents cracking, enhances shelf life, and supports healthy flowering and fruit development."
  },
  {
    id: 219,
    productName: "UTSAV NPK 16:08:24",
    technicalName: "Nitrogen 16% + Phosphorus 8% + Potassium 24%",
    formulation: "Water Soluble Powder",
    category: "NPK Fertilizer",
    packSize: "1 Kg",
    image: "/images/products/218.jpg",
    description: "UTSAV NPK 16:08:24 is a potassium-rich fertilizer suitable for flowering and fruit development. It improves fruit size, color, sweetness, and increases plant resistance to stress conditions."
  },
  {
    id: 220,
    productName: "UTSAV NPK 00:60:20",
    technicalName: "Phosphorus 60% + Potassium 20%",
    formulation: "Water Soluble Powder",
    category: "NPK Fertilizer",
    packSize: "1 Kg",
    image: "/images/products/219.jpg",
    description: "UTSAV NPK 00:60:20 is a nitrogen-free fertilizer rich in phosphorus and potassium. It promotes strong root growth, flowering, fruit setting, and is ideal during fruiting stages where nitrogen control is required."
  },
  {
    id: 221,
    productName: "UTSAV NPK 00:00:23",
    technicalName: "Potassium Schoenite",
    formulation: "Water Soluble Crystals",
    category: "NPK Fertilizer",
    packSize: "1 Kg",
    image: "/images/products/220.jpg",
    description: "UTSAV NPK 00:00:23 supplies potassium along with magnesium and sulphur. It enhances photosynthesis, improves fruit quality, increases stress tolerance, and supports balanced crop nutrition."
  },
  {
    id: 222,
    productName: "UTSAV NPK 28:28:00",
    technicalName: "Nitrogen 28% + Phosphorus 28%",
    formulation: "Water Soluble Powder",
    category: "NPK Fertilizer",
    packSize: "1 Kg",
    image: "/images/products/221.jpg",
    description: "UTSAV NPK 28:28:00 is ideal for early vegetative growth. It promotes rapid plant development, strong root formation, and efficient nutrient absorption for healthy crop establishment."
  },
  {
    id: 223,
    productName: "UTSAV Zinc Sulphate 33%",
    technicalName: "Zinc Sulphate Monohydrate",
    formulation: "Crystalline Powder",
    category: "NPK Fertilizer",
    packSize: "1 Kg",
    image: "/images/products/222.jpg",
    description: "UTSAV Zinc Sulphate 33% Monohydrate corrects zinc deficiency and supports enzyme activation and hormone balance. It enhances leaf growth, flowering, and overall crop productivity."
  },
  {
    id: 224,
    productName: "UTSAV Manganese Sulphate",
    technicalName: "Manganese Sulphate (MnSO4)",
    formulation: "Water Soluble Powder",
    category: "NPK Fertilizer",
    packSize: "1 Kg",
    image: "/images/products/223.jpg",
    description: "UTSAV Manganese Sulphate supplies essential manganese required for photosynthesis and enzyme activation. It corrects manganese deficiency, improves leaf color, and enhances crop yield and quality."
  },
  {
    id: 225,
    productName: "UTSAV Ammonium Sulphate",
    technicalName: "Ammonium Sulphate",
    formulation: "Granular",
    category: "NPK Fertilizer",
    packSize: "1 Kg",
    image: "/images/products/224.jpg",
    description: "UTSAV Ammonium Sulphate provides nitrogen and sulphur essential for vegetative growth and protein synthesis. It improves soil fertility, enhances crop vigor, and is highly effective in sulphur-deficient soils."
  },
  {
    id: 226,
    productName: "UTSAV Ferrous Sulphate",
    technicalName: "Ferrous Sulphate (FeSO4)",
    formulation: "Crystalline Powder",
    category: "NPK Fertilizer",
    packSize: "1 Kg",
    image: "/images/products/225.jpg",
    description: "UTSAV Ferrous Sulphate corrects iron deficiency in crops and improves chlorophyll formation. It enhances leaf greening, supports photosynthesis, and promotes healthy plant growth in iron-deficient soils."
  },
  {
    id: 227,
    productName: "UTSAV Copper Sulphate",
    technicalName: "Copper Sulphate",
    formulation: "Crystalline Powder",
    category: "NPK Fertilizer",
    packSize: "1 Kg",
    image: "/images/products/226.jpg",
    description: "UTSAV Copper Sulphate supplies essential copper required for enzyme activation and reproductive growth. It helps prevent copper deficiency, improves plant vigor, and supports healthy flowering and fruiting."
  },
  {
    id: 228,
    productName: "UTSAV Boron 20%",
    technicalName: "Disodium Octaborate Tetrahydrate",
    formulation: "Water Soluble Powder",
    category: "NPK Fertilizer",
    packSize: "1 Kg",
    image: "/images/products/227.jpg",
    description: "UTSAV Boron 20% corrects boron deficiency and supports cell division, pollination, and fruit setting. It improves flower retention, enhances seed formation, and increases crop quality and yield."
  },
  {
    id: 229,
    productName: "UTSAV Boron 10.5%",
    technicalName: "Borax (Sodium Tetraborate)",
    formulation: "Crystalline Powder",
    category: "NPK Fertilizer",
    packSize: "1 Kg",
    image: "/images/products/228.jpg",
    description: "UTSAV Boron 10.5% improves pollen viability, fruit setting, and root development. It helps eliminate boron deficiency symptoms and enhances crop productivity across field and horticultural crops."
  },
  {
    id: 230,
    productName: "UTSAV Chelated Multi Micronutrients",
    technicalName: "Chelated Micronutrient Mixture",
    formulation: "Water Soluble Powder",
    category: "NPK Fertilizer",
    packSize: "1 Kg",
    image: "/images/products/229.jpg",
    description: "UTSAV Chelated Multi Micronutrients provides balanced micronutrient nutrition including zinc, iron, manganese, copper, boron, molybdenum, and magnesium. It supports chlorophyll formation, enzyme activity, and overall plant health."
  },
  {
    id: 231,
    productName: "UTSAV Amino Shiny Ball",
    technicalName: "Amino Acid Based Growth Promoter",
    formulation: "Granular Ball Form",
    category: "NPK Fertilizer",
    packSize: "1 Kg",
    image: "/images/products/230.jpg",
    description: "UTSAV Amino Shiny Ball is an amino acid based growth enhancer enriched with humic substances and essential nutrients. It improves root development, enhances flowering, supports soil conditioning, and increases overall crop productivity."
  }
];

export default products;